export const cscStates = [
  { name: "Andaman and Nicobar Islands" },
  { name: "Andhra Pradesh" },
  { name: "Arunachal Pradesh" },
  { name: "Assam" },
  { name: "Bihar" },
  { name: "Chandigarh" },
  { name: "Chhattisgarh" },
  { name: "Dadra and Nagar Haveli and Daman and Diu" },
  { name: "Delhi" },
  { name: "Goa" },
  { name: "Gujarat" },
  { name: "Haryana" },
  { name: "Himachal Pradesh" },
  { name: "Jammu and Kashmir" },
  { name: "Jharkhand" },
  { name: "Karnataka" },
  { name: "Kerala" },
  { name: "Ladakh" },
  { name: "Lakshadweep" },
  { name: "Madhya Pradesh" },
  { name: "Maharashtra" },
  { name: "Manipur" },
  { name: "Meghalaya" },
  { name: "Mizoram" },
  { name: "Nagaland" },
  { name: "Odisha" },
  { name: "Puducherry" },
  { name: "Punjab" },
  { name: "Rajasthan" },
  { name: "Sikkim" },
  { name: "Tamil Nadu" },
  { name: "Telangana" },
  { name: "Tripura" },
  { name: "Uttar Pradesh" },
  { name: "Uttarakhand" },
  { name: "West Bengal" }
];

export const cscCities = [
  {
    "Andaman and Nicobar Islands": [
      { name: "Bamboo Flat" },
      { name: "Nicobar" },
      { name: "Port Blair" },
      { name: "South Andaman" }
    ],
    "Andhra Pradesh": [
      { name: "Addanki" },
      { name: "Adoni" },
      { name: "Akasahebpet" },
      { name: "Akividu" },
      { name: "Akkarampalle" },
      { name: "Amalapuram" },
      { name: "Amudalavalasa" },
      { name: "Anakapalle" },
      { name: "Anantapur" },
      { name: "Atmakur" },
      { name: "Attili" },
      { name: "Avanigadda" },
      { name: "Badvel" },
      { name: "Banganapalle" },
      { name: "Bapatla" },
      { name: "Betamcherla" },
      { name: "Bhattiprolu" },
      { name: "Bhimavaram" },
      { name: "Bhimunipatnam" },
      { name: "Bobbili" },
      { name: "Challapalle" },
      { name: "Chemmumiahpet" },
      { name: "Chilakalurupet" },
      { name: "Chinnachowk" },
      { name: "Chipurupalle" },
      { name: "Chirala" },
      { name: "Chittoor" },
      { name: "Chodavaram" },
      { name: "Cuddapah" },
      { name: "Cumbum" },
      { name: "Darsi" },
      { name: "Dharmavaram" },
      { name: "Dhone" },
      { name: "Diguvametta" },
      { name: "East Godavari" },
      { name: "Elamanchili" },
      { name: "Ellore" },
      { name: "Emmiganur" },
      { name: "Erraguntla" },
      { name: "Etikoppaka" },
      { name: "Gajuwaka" },
      { name: "Ganguvada" },
      { name: "Gannavaram" },
      { name: "Giddalur" },
      { name: "Gokavaram" },
      { name: "Gorantla" },
      { name: "GovindapuramChilakaluripetGuntur" },
      { name: "Gudivada" },
      { name: "Gudlavalleru" },
      { name: "Gudur" },
      { name: "Guntakal Junction" },
      { name: "Guntur" },
      { name: "Hindupur" },
      { name: "Ichchapuram" },
      { name: "Jaggayyapeta" },
      { name: "Jammalamadugu" },
      { name: "Kadiri" },
      { name: "Kaikalur" },
      { name: "Kakinada" },
      { name: "Kalyandurg" },
      { name: "Kamalapuram" },
      { name: "Kandukur" },
      { name: "Kanigiri" },
      { name: "Kankipadu" },
      { name: "Kanuru" },
      { name: "Kavali" },
      { name: "Kolanukonda" },
      { name: "Kondapalle" },
      { name: "Korukollu" },
      { name: "Kosigi" },
      { name: "Kovvur" },
      { name: "Krishna" },
      { name: "Kuppam" },
      { name: "Kurnool" },
      { name: "Macherla" },
      { name: "Machilipatnam" },
      { name: "Madanapalle" },
      { name: "Madugula" },
      { name: "Mandapeta" },
      { name: "Mandasa" },
      { name: "Mangalagiri" },
      { name: "Markapur" },
      { name: "Nagari" },
      { name: "Nagireddipalli" },
      { name: "Nandigama" },
      { name: "Nandikotkur" },
      { name: "Nandyal" },
      { name: "Narasannapeta" },
      { name: "Narasapur" },
      { name: "Narasaraopet" },
      { name: "Narasingapuram" },
      { name: "Narayanavanam" },
      { name: "Narsipatnam" },
      { name: "Nayudupet" },
      { name: "Nellore" },
      { name: "Nidadavole" },
      { name: "Nuzvid" },
      { name: "Ongole" },
      { name: "Pakala" },
      { name: "Palakollu" },
      { name: "Palasa" },
      { name: "Palkonda" },
      { name: "Pallevada" },
      { name: "Palmaner" },
      { name: "Parlakimidi" },
      { name: "Parvatipuram" },
      { name: "Pavuluru" },
      { name: "Pedana" },
      { name: "pedda nakkalapalem" },
      { name: "Peddapuram" },
      { name: "Penugonda" },
      { name: "Penukonda" },
      { name: "Phirangipuram" },
      { name: "Pippara" },
      { name: "Pithapuram" },
      { name: "Polavaram" },
      { name: "Ponnur" },
      { name: "Ponnuru" },
      { name: "Prakasam" },
      { name: "Proddatur" },
      { name: "Pulivendla" },
      { name: "Punganuru" },
      { name: "Puttaparthi" },
      { name: "Puttur" },
      { name: "Rajahmundry" },
      { name: "Ramachandrapuram" },
      { name: "Ramanayyapeta" },
      { name: "Ramapuram" },
      { name: "Rampachodavaram" },
      { name: "Rayachoti" },
      { name: "Rayadrug" },
      { name: "Razam" },
      { name: "Razampeta" },
      { name: "Razole" },
      { name: "Renigunta" },
      { name: "Repalle" },
      { name: "Salur" },
      { name: "Samalkot" },
      { name: "Sattenapalle" },
      { name: "Singarayakonda" },
      { name: "Sompeta" },
      { name: "Srikakulam" },
      { name: "Srisailain" },
      { name: "Suluru" },
      { name: "Tadepalle" },
      { name: "Tadepallegudem" },
      { name: "Tadpatri" },
      { name: "Tanuku" },
      { name: "Tekkali" },
      { name: "Tirumala" },
      { name: "Tirupati" },
      { name: "Tuni" },
      { name: "Uravakonda" },
      { name: "vadlamuru" },
      { name: "Vadlapudi" },
      { name: "Venkatagiri" },
      { name: "Vepagunta" },
      { name: "Vetapalem" },
      { name: "Vijayawada" },
      { name: "Vinukonda" },
      { name: "Visakhapatnam" },
      { name: "Vizianagaram" },
      { name: "Vizianagaram District" },
      { name: "Vuyyuru" },
      { name: "West Godavari" },
      { name: "Yanam" },
      { name: "Yanamalakuduru" },
      { name: "Yarada" }
    ],
    "Arunachal Pradesh": [
      { name: "Along" },
      { name: "Anjaw" },
      { name: "Basar" },
      { name: "Bomdila" },
      { name: "Changlang" },
      { name: "Dibang Valley" },
      { name: "East Kameng" },
      { name: "East Siang" },
      { name: "Hayuliang" },
      { name: "Itanagar" },
      { name: "Khonsa" },
      { name: "Kurung Kumey" },
      { name: "Lohit District" },
      { name: "Lower Dibang Valley" },
      { name: "Lower Subansiri" },
      { name: "Margherita" },
      { name: "Naharlagun" },
      { name: "Pasighat" },
      { name: "Tawang" },
      { name: "Tezu" },
      { name: "Tirap" },
      { name: "Upper Siang" },
      { name: "Upper Subansiri" },
      { name: "West Kameng" },
      { name: "West Siang" },
      { name: "Ziro" }
    ],
    "Assam": [
      { name: "Abhayapuri" },
      { name: "Amguri" },
      { name: "Badarpur" },
      { name: "Baksa" },
      { name: "Barpathar" },
      { name: "Barpeta" },
      { name: "Barpeta Road" },
      { name: "Basugaon" },
      { name: "Bihpuriagaon" },
      { name: "Bijni" },
      { name: "Bilasipara" },
      { name: "Bokajan" },
      { name: "Bokakhat" },
      { name: "Bongaigaon" },
      { name: "Cachar" },
      { name: "Chabua" },
      { name: "Chapar" },
      { name: "Chirang" },
      { name: "Darrang" },
      { name: "Dergaon" },
      { name: "Dhekiajuli" },
      { name: "Dhemaji" },
      { name: "Dhing" },
      { name: "Dhubri" },
      { name: "Dibrugarh" },
      { name: "Digboi" },
      { name: "Dima Hasao District" },
      { name: "Diphu" },
      { name: "Dispur" },
      { name: "Duliagaon" },
      { name: "Dum Duma" },
      { name: "Gauripur" },
      { name: "Goalpara" },
      { name: "Gohpur" },
      { name: "Golaghat" },
      { name: "Golakganj" },
      { name: "Goshaingaon" },
      { name: "Guwahati" },
      { name: "Haflong" },
      { name: "Hailakandi" },
      { name: "Hajo" },
      { name: "Hojai" },
      { name: "Howli" },
      { name: "Jogighopa" },
      { name: "Jorhat" },
      { name: "Kamrup" },
      { name: "Kamrup Metropolitan" },
      { name: "Karbi Anglong" },
      { name: "Karimganj" },
      { name: "Kharupatia" },
      { name: "Kokrajhar" },
      { name: "Lakhimpur" },
      { name: "Lakhipur" },
      { name: "Lala" },
      { name: "Lumding Railway Colony" },
      { name: "Mahur" },
      { name: "Maibong" },
      { name: "Makum" },
      { name: "Mangaldai" },
      { name: "Mariani" },
      { name: "Moranha" },
      { name: "Morigaon" },
      { name: "Nagaon" },
      { name: "Nahorkatiya" },
      { name: "Nalbari" },
      { name: "Namrup" },
      { name: "Nazira" },
      { name: "North Guwahati" },
      { name: "North Lakhimpur" },
      { name: "Numaligarh" },
      { name: "Palasbari" },
      { name: "Raha" },
      { name: "Rangapara" },
      { name: "Rangia" },
      { name: "Sapatgram" },
      { name: "Sarupathar" },
      { name: "Sibsagar" },
      { name: "Silapathar" },
      { name: "Silchar" },
      { name: "Soalkuchi" },
      { name: "Sonari" },
      { name: "Sonitpur" },
      { name: "Sorbhog" },
      { name: "Tezpur" },
      { name: "Tinsukia" },
      { name: "Titabar" },
      { name: "Udalguri" }
    ],
    "Bihar": [
      { name: "Amarpur" },
      { name: "Araria" },
      { name: "Arrah" },
      { name: "Arwal" },
      { name: "Asarganj" },
      { name: "Aurangabad" },
      { name: "Bagaha" },
      { name: "Bahadurganj" },
      { name: "Bairagnia" },
      { name: "Baisi" },
      { name: "Bakhtiyarpur" },
      { name: "Bangaon" },
      { name: "Banka" },
      { name: "Banmankhi" },
      { name: "Bar Bigha" },
      { name: "Barauli" },
      { name: "Barh" },
      { name: "Barhiya" },
      { name: "Bariarpur" },
      { name: "Baruni" },
      { name: "Begusarai" },
      { name: "Belsand" },
      { name: "Bettiah" },
      { name: "Bhabhua" },
      { name: "Bhagalpur" },
      { name: "Bhagirathpur" },
      { name: "Bhawanipur" },
      { name: "Bhojpur" },
      { name: "Bihar Sharif" },
      { name: "Bihariganj" },
      { name: "Bikramganj" },
      { name: "Birpur" },
      { name: "Buddh Gaya" },
      { name: "Buxar" },
      { name: "Chakia" },
      { name: "Chapra" },
      { name: "Chhatapur" },
      { name: "Colgong" },
      { name: "Dalsingh Sarai" },
      { name: "Darbhanga" },
      { name: "Daudnagar" },
      { name: "Dehri" },
      { name: "Dhaka" },
      { name: "Dighwara" },
      { name: "Dinapore" },
      { name: "Dumra" },
      { name: "Dumraon" },
      { name: "Fatwa" },
      { name: "Forbesganj" },
      { name: "Gaya" },
      { name: "Ghoga" },
      { name: "Gopalganj" },
      { name: "Hajipur" },
      { name: "Hilsa" },
      { name: "Hisua" },
      { name: "Islampur" },
      { name: "Jagdispur" },
      { name: "Jahanabad" },
      { name: "Jamalpur" },
      { name: "Jamui" },
      { name: "Jaynagar" },
      { name: "Jehanabad" },
      { name: "Jha-Jha" },
      { name: "Jhanjharpur" },
      { name: "Jogbani" },
      { name: "Kaimur District" },
      { name: "Kasba" },
      { name: "Katihar" },
      { name: "Khagaria" },
      { name: "Khagaul" },
      { name: "Kharagpur" },
      { name: "Khusropur" },
      { name: "Kishanganj" },
      { name: "Koath" },
      { name: "Koelwar" },
      { name: "Lakhisarai" },
      { name: "Lalganj" },
      { name: "Luckeesarai" },
      { name: "Madhepura" },
      { name: "Madhipura" },
      { name: "Madhubani" },
      { name: "Maharajgani" },
      { name: "Mairwa" },
      { name: "Maner" },
      { name: "Manihari" },
      { name: "Marhaura" },
      { name: "Masaurhi Buzurg" },
      { name: "Mohiuddinnagar" },
      { name: "Mokameh" },
      { name: "Monghyr" },
      { name: "Mothihari" },
      { name: "Munger" },
      { name: "Murliganj" },
      { name: "Muzaffarpur" },
      { name: "Nabinagar" },
      { name: "Nalanda" },
      { name: "Nasriganj" },
      { name: "Naugachhia" },
      { name: "Nawada" },
      { name: "Nirmali" },
      { name: "Pashchim Champaran" },
      { name: "Patna" },
      { name: "Piro" },
      { name: "Pupri" },
      { name: "Purba Champaran" },
      { name: "Purnia" },
      { name: "Rafiganj" },
      { name: "Raghunathpur" },
      { name: "Rajgir" },
      { name: "Ramnagar" },
      { name: "Raxaul" },
      { name: "Revelganj" },
      { name: "Rohtas" },
      { name: "Rusera" },
      { name: "Sagauli" },
      { name: "Saharsa" },
      { name: "Samastipur" },
      { name: "Saran" },
      { name: "Shahbazpur" },
      { name: "Shahpur" },
      { name: "Sheikhpura" },
      { name: "Sheohar" },
      { name: "Sherghati" },
      { name: "Silao" },
      { name: "Sitamarhi" },
      { name: "Siwan" },
      { name: "Supaul" },
      { name: "Teghra" },
      { name: "Tekari" },
      { name: "Thakurganj" },
      { name: "Vaishali" },
      { name: "Waris Aliganj" }
    ],
    "Chandigarh": [
      { name: "Chandigarh" }
    ],
    "Chhattisgarh": [
      { name: "Akaltara" },
      { name: "Ambagarh Chauki" },
      { name: "Ambikapur" },
      { name: "Arang" },
      { name: "Baikunthpur" },
      { name: "Balod" },
      { name: "Baloda" },
      { name: "Baloda Bazar" },
      { name: "Basna" },
      { name: "Bastar" },
      { name: "Bemetara" },
      { name: "Bhanpuri" },
      { name: "Bhatapara" },
      { name: "Bhatgaon" },
      { name: "Bhilai" },
      { name: "Bijapur" },
      { name: "Bilaspur" },
      { name: "Champa" },
      { name: "Chhuikhadan" },
      { name: "Deori" },
      { name: "Dhamtari" },
      { name: "Dongargaon" },
      { name: "Dongargarh" },
      { name: "Durg" },
      { name: "Gandai" },
      { name: "Gariaband" },
      { name: "Gaurela" },
      { name: "Gharghoda" },
      { name: "Gidam" },
      { name: "Jagdalpur" },
      { name: "Janjgir" },
      { name: "Janjgir-Champa" },
      { name: "Jashpur" },
      { name: "Jashpurnagar" },
      { name: "Junagarh" },
      { name: "Kabeerdham" },
      { name: "Kanker" },
      { name: "Katghora" },
      { name: "Kawardha" },
      { name: "Khairagarh" },
      { name: "Khamharia" },
      { name: "Kharod" },
      { name: "Kharsia" },
      { name: "Kirandul" },
      { name: "Kondagaon" },
      { name: "Korba" },
      { name: "Koriya" },
      { name: "Kota" },
      { name: "Kotaparh" },
      { name: "Kumhari" },
      { name: "Kurud" },
      { name: "Lormi" },
      { name: "Mahasamund" },
      { name: "Mungeli" },
      { name: "Narayanpur" },
      { name: "Narharpur" },
      { name: "Pandaria" },
      { name: "Pandatarai" },
      { name: "Pasan" },
      { name: "Patan" },
      { name: "Pathalgaon" },
      { name: "Pendra" },
      { name: "Pithora" },
      { name: "Raigarh" },
      { name: "Raipur" },
      { name: "Raj Nandgaon" },
      { name: "Raj-Nandgaon" },
      { name: "Ramanuj Ganj" },
      { name: "Ratanpur" },
      { name: "Sakti" },
      { name: "Saraipali" },
      { name: "Sarangarh" },
      { name: "Seorinarayan" },
      { name: "Simga" },
      { name: "Surguja" },
      { name: "Takhatpur" },
      { name: "Umarkot" },
      { name: "Uttar Bastar Kanker" }
    ],
    "Dadra and Nagar Haveli and Daman and Diu": [
      { name: "Amli" },
      { name: "Dadra" },
      { name: "Dadra & Nagar Haveli" },
      { name: "Daman" },
      { name: "Daman District" },
      { name: "Diu" },
      { name: "Silvassa" }
    ],
    "Delhi": [
      { name: "Alipur" },
      { name: "Bawana" },
      { name: "Central Delhi" },
      { name: "Delhi" },
      { name: "Deoli" },
      { name: "East Delhi" },
      { name: "Karol Bagh" },
      { name: "Najafgarh" },
      { name: "Nangloi Jat" },
      { name: "Narela" },
      { name: "New Delhi" },
      { name: "North Delhi" },
      { name: "North East Delhi" },
      { name: "North West Delhi" },
      { name: "Pitampura" },
      { name: "Rohini" },
      { name: "South Delhi" },
      { name: "South West Delhi" },
      { name: "West Delhi" }
    ],
    "Goa": [
      { name: "Aldona" },
      { name: "Arambol" },
      { name: "Baga" },
      { name: "Bambolim" },
      { name: "Bandora" },
      { name: "Benaulim" },
      { name: "Calangute" },
      { name: "Candolim" },
      { name: "Carapur" },
      { name: "Cavelossim" },
      { name: "Chicalim" },
      { name: "Chinchinim" },
      { name: "Colovale" },
      { name: "Colva" },
      { name: "Cortalim" },
      { name: "Cuncolim" },
      { name: "Curchorem" },
      { name: "Curti" },
      { name: "Davorlim" },
      { name: "Dicholi" },
      { name: "Goa Velha" },
      { name: "Guirim" },
      { name: "Jua" },
      { name: "Kankon" },
      { name: "Madgaon" },
      { name: "Mapuca" },
      { name: "Morjim" },
      { name: "Mormugao" },
      { name: "Navelim" },
      { name: "North Goa" },
      { name: "Palle" },
      { name: "Panaji" },
      { name: "Pernem" },
      { name: "Ponda" },
      { name: "Quepem" },
      { name: "Queula" },
      { name: "Raia" },
      { name: "Saligao" },
      { name: "Sancoale" },
      { name: "Sanguem" },
      { name: "Sanquelim" },
      { name: "Sanvordem" },
      { name: "Serula" },
      { name: "Solim" },
      { name: "South Goa" },
      { name: "Taleigao" },
      { name: "Vagator" },
      { name: "Valpoy" },
      { name: "Varca" },
      { name: "Vasco da Gama" }
    ],
    "Gujarat": [
      { name: "Abrama" },
      { name: "Adalaj" },
      { name: "Agol" },
      { name: "Ahmedabad" },
      { name: "Ahwa" },
      { name: "Akrund" },
      { name: "Amod" },
      { name: "Amod" },
      { name: "Amreli" },
      { name: "Amroli" },
      { name: "Anand" },
      { name: "Anjar" },
      { name: "Ankleshwar" },
      { name: "Babra" },
      { name: "Bagasara" },
      { name: "Bagasra" },
      { name: "Bakharla" },
      { name: "Balagam" },
      { name: "Balasinor" },
      { name: "Balisana" },
      { name: "Bamanbore" },
      { name: "Banas Kantha" },
      { name: "Bandia" },
      { name: "Bantva" },
      { name: "Bardoli" },
      { name: "Bedi" },
      { name: "Bhachau" },
      { name: "Bhadran" },
      { name: "Bhandu" },
      { name: "Bhanvad" },
      { name: "Bharuch" },
      { name: "Bhatha" },
      { name: "Bhavnagar" },
      { name: "Bhayavadar" },
      { name: "Bhildi" },
      { name: "Bhojpur Dharampur" },
      { name: "Bhuj" },
      { name: "Bilimora" },
      { name: "Bilkha" },
      { name: "Borsad" },
      { name: "Botad" },
      { name: "Chaklasi" },
      { name: "Chalala" },
      { name: "Chaloda" },
      { name: "Champaner" },
      { name: "Chanasma" },
      { name: "Chhala" },
      { name: "Chhota Udepur" },
      { name: "Chikhli" },
      { name: "Chotila" },
      { name: "Chuda" },
      { name: "Dabhoda" },
      { name: "Dabhoi" },
      { name: "Dahegam" },
      { name: "Dahod" },
      { name: "Dakor" },
      { name: "Damnagar" },
      { name: "Dandi" },
      { name: "Dangs (India)" },
      { name: "Danta" },
      { name: "Dayapar" },
      { name: "Delvada" },
      { name: "Delwada" },
      { name: "Detroj" },
      { name: "Devbhumi Dwarka" },
      { name: "Devgadh Bariya" },
      { name: "Dhandhuka" },
      { name: "Dhanera" },
      { name: "Dhansura" },
      { name: "Dharampur" },
      { name: "Dharasana" },
      { name: "Dhari" },
      { name: "Dhasa" },
      { name: "Dhola" },
      { name: "Dholera" },
      { name: "Dholka" },
      { name: "Dhoraji" },
      { name: "Dhrangadhra" },
      { name: "Dhrol" },
      { name: "Dhuwaran" },
      { name: "Disa" },
      { name: "Dohad" },
      { name: "Dumkhal" },
      { name: "Dungarpur" },
      { name: "Dwarka" },
      { name: "Gadhada" },
      { name: "Gandevi" },
      { name: "Gandhidham" },
      { name: "Gandhinagar" },
      { name: "Gariadhar" },
      { name: "Ghodasar" },
      { name: "Ghogha" },
      { name: "Gir Somnath" },
      { name: "Godhra" },
      { name: "Gondal" },
      { name: "Gorwa" },
      { name: "Halenda" },
      { name: "Halol" },
      { name: "Halvad" },
      { name: "Hansot" },
      { name: "Harij" },
      { name: "Harsol" },
      { name: "Hathuran" },
      { name: "Himatnagar" },
      { name: "Idar" },
      { name: "Jakhau" },
      { name: "Jalalpore" },
      { name: "Jalalpur" },
      { name: "Jalia" },
      { name: "Jambuda" },
      { name: "Jambusar" },
      { name: "Jamnagar" },
      { name: "Jarod" },
      { name: "Jasdan" },
      { name: "Jetalpur" },
      { name: "Jetalsar" },
      { name: "Jetpur" },
      { name: "Jetpur (Navagadh)" },
      { name: "Jhalod" },
      { name: "Jhulasan" },
      { name: "Jodhpur" },
      { name: "Jodhpur (Ahmedabad)" },
      { name: "Jodia" },
      { name: "Jodiya Bandar" },
      { name: "Junagadh" },
      { name: "Kachchh" },
      { name: "Kachholi" },
      { name: "Kadi" },
      { name: "Kadod" },
      { name: "Kalavad" },
      { name: "Kalol" },
      { name: "Kandla" },
      { name: "Kandla port" },
      { name: "Kanodar" },
      { name: "Kapadvanj" },
      { name: "Karamsad" },
      { name: "Kariana" },
      { name: "Karjan" },
      { name: "Kathor" },
      { name: "Katpur" },
      { name: "Kavant" },
      { name: "Kawant" },
      { name: "Kayavarohan" },
      { name: "Kerwada" },
      { name: "Keshod" },
      { name: "Khambhalia" },
      { name: "Khambhat" },
      { name: "Khavda" },
      { name: "Kheda" },
      { name: "Khedbrahma" },
      { name: "Khedoi" },
      { name: "Kherali" },
      { name: "Kheralu" },
      { name: "Kodinar" },
      { name: "Kosamba" },
      { name: "Kothara" },
      { name: "Kotharia" },
      { name: "Kukarmunda" },
      { name: "Kukma" },
      { name: "Kundla" },
      { name: "Kutch district" },
      { name: "Kutiyana" },
      { name: "Ladol" },
      { name: "Lakhpat" },
      { name: "Lakhtar" },
      { name: "Lalpur" },
      { name: "Langhnaj" },
      { name: "Lathi" },
      { name: "Limbdi" },
      { name: "Limkheda" },
      { name: "Lunavada" },
      { name: "Madhavpur Ghed" },
      { name: "Madhi" },
      { name: "Mahemdavad" },
      { name: "Mahesana" },
      { name: "Mahisa" },
      { name: "Mahudha" },
      { name: "Mahuva" },
      { name: "Mahuva (Surat)" },
      { name: "Malpur" },
      { name: "Manavadar" },
      { name: "Mandal" },
      { name: "Mandvi" },
      { name: "Mandvi (Surat)" },
      { name: "Mangrol" },
      { name: "Mangrol (Junagadh)" },
      { name: "Mansa" },
      { name: "Meghraj" },
      { name: "Mehsana" },
      { name: "Mendarda" },
      { name: "Mithapur" },
      { name: "Modasa" },
      { name: "Morbi" },
      { name: "Morva (Hadaf)" },
      { name: "Morwa" },
      { name: "Mundra" },
      { name: "Nadiad" },
      { name: "Nadiad" },
      { name: "Nagwa" },
      { name: "Naldhara" },
      { name: "Naliya" },
      { name: "Nargol" },
      { name: "Narmada" },
      { name: "Naroda" },
      { name: "Navsari" },
      { name: "Nikora" },
      { name: "Nizar" },
      { name: "Odadar" },
      { name: "Okha" },
      { name: "Olpad" },
      { name: "Paddhari" },
      { name: "Padra" },
      { name: "Palanpur" },
      { name: "Palanswa" },
      { name: "Palitana" },
      { name: "Paliyad" },
      { name: "Paliyad (Bhavnagar)" },
      { name: "Palsana" },
      { name: "Panch Mahals" },
      { name: "Panchmahal district" },
      { name: "Pardi" },
      { name: "Parnera" },
      { name: "Patan" },
      { name: "Pavi Jetpur" },
      { name: "Petlad" },
      { name: "Pipavav" },
      { name: "Piplod" },
      { name: "Porbandar" },
      { name: "Prabhas Patan" },
      { name: "Prantij" },
      { name: "Radhanpur" },
      { name: "Rajkot" },
      { name: "Rajpipla" },
      { name: "Rajula" },
      { name: "Ranavav" },
      { name: "Ranpur" },
      { name: "Rapar" },
      { name: "Reha" },
      { name: "Roha" },
      { name: "Sabar Kantha" },
      { name: "Sachin" },
      { name: "Salaya" },
      { name: "Samakhiali" },
      { name: "Sanand" },
      { name: "Sankheda" },
      { name: "Sarbhon" },
      { name: "Sardoi" },
      { name: "Sarkhej" },
      { name: "Sathamba" },
      { name: "Savarkundla" },
      { name: "Savli" },
      { name: "Sayla" },
      { name: "Shahpur" },
      { name: "Shivrajpur" },
      { name: "Siddhpur" },
      { name: "Sihor" },
      { name: "Sikka" },
      { name: "Sinor" },
      { name: "Sojitra" },
      { name: "Songadh" },
      { name: "Supedi" },
      { name: "Surat" },
      { name: "Surendranagar" },
      { name: "Sutrapada" },
      { name: "Talaja" },
      { name: "Tankara" },
      { name: "Tapi" },
      { name: "Than" },
      { name: "Thangadh" },
      { name: "Tharad" },
      { name: "Thasra" },
      { name: "The Dangs" },
      { name: "Umarpada" },
      { name: "Umrala" },
      { name: "Umreth" },
      { name: "Un" },
      { name: "Una" },
      { name: "Unjha" },
      { name: "Upleta" },
      { name: "Utran" },
      { name: "Vadgam" },
      { name: "Vadnagar" },
      { name: "Vadodara" },
      { name: "Vaghodia" },
      { name: "Vaghodia INA" },
      { name: "Vallabh Vidyanagar" },
      { name: "Vallabhipur" },
      { name: "Valsad" },
      { name: "Vanala" },
      { name: "Vansda" },
      { name: "Vanthli" },
      { name: "Vapi" },
      { name: "Vartej" },
      { name: "Vasa" },
      { name: "Vasavad" },
      { name: "Vaso" },
      { name: "Vataman" },
      { name: "Vejalpur" },
      { name: "Veraval" },
      { name: "Vijapur" },
      { name: "Vinchhiya" },
      { name: "Vinchia" },
      { name: "Viramgam" },
      { name: "Virpur" },
      { name: "Visavadar" },
      { name: "Visnagar" },
      { name: "Vyara" },
      { name: "Wadhai" },
      { name: "Wadhwan" },
      { name: "Waghai" },
      { name: "Wankaner" }
    ],
    "Haryana": [
      { name: "Ambala" },
      { name: "Asandh" },
      { name: "Ateli Mandi" },
      { name: "Bahadurgarh" },
      { name: "Bara Uchana" },
      { name: "Barwala" },
      { name: "Bawal" },
      { name: "Beri Khas" },
      { name: "Bhiwani" },
      { name: "Bilaspur" },
      { name: "Buriya" },
      { name: "Charkhi Dadri" },
      { name: "Chhachhrauli" },
      { name: "Dabwali" },
      { name: "Dharuhera" },
      { name: "Ellenabad" },
      { name: "Faridabad" },
      { name: "Faridabad District" },
      { name: "Farrukhnagar" },
      { name: "Fatehabad" },
      { name: "Fatehabad District" },
      { name: "Firozpur Jhirka" },
      { name: "Gharaunda" },
      { name: "Gohana" },
      { name: "Gorakhpur" },
      { name: "Gurgaon" },
      { name: "Hansi" },
      { name: "Hasanpur" },
      { name: "Hisar" },
      { name: "Hodal" },
      { name: "Inda Chhoi" },
      { name: "Indri" },
      { name: "Jagadhri" },
      { name: "Jakhal" },
      { name: "Jhajjar" },
      { name: "Jind" },
      { name: "Kaithal" },
      { name: "Kalanaur" },
      { name: "Kalanwali" },
      { name: "Kanina Khas" },
      { name: "Karnal" },
      { name: "Kharkhauda" },
      { name: "Kheri Sampla" },
      { name: "Kurukshetra" },
      { name: "Ladwa" },
      { name: "Loharu" },
      { name: "Maham" },
      { name: "Mahendragarh" },
      { name: "Mandholi Kalan" },
      { name: "Mustafabad" },
      { name: "Narayangarh" },
      { name: "Narnaul" },
      { name: "Narnaund" },
      { name: "Narwana" },
      { name: "Nilokheri" },
      { name: "Nuh" },
      { name: "Palwal" },
      { name: "Panchkula" },
      { name: "Panipat" },
      { name: "Pataudi" },
      { name: "Pehowa" },
      { name: "Pinjaur" },
      { name: "Punahana" },
      { name: "Pundri" },
      { name: "Radaur" },
      { name: "Rania" },
      { name: "Ratia" },
      { name: "Rewari" },
      { name: "Rewari District" },
      { name: "Rohtak" },
      { name: "Safidon" },
      { name: "Samalkha" },
      { name: "Shadipur Julana" },
      { name: "Shahabad" },
      { name: "Sirsa" },
      { name: "Sohna" },
      { name: "Sonipat" },
      { name: "Taoru" },
      { name: "Thanesar" },
      { name: "Tohana" },
      { name: "Tosham" },
      { name: "Uklana" },
      { name: "Yamunanagar" }
    ],
    "Himachal Pradesh": [
      { name: "Arki" },
      { name: "Baddi" },
      { name: "Banjar" },
      { name: "Bilaspur" },
      { name: "Chamba" },
      { name: "Chaupal" },
      { name: "Chowari" },
      { name: "Chuari Khas" },
      { name: "Dagshai" },
      { name: "Dalhousie" },
      { name: "Daulatpur" },
      { name: "Dera Gopipur" },
      { name: "Dharamsala" },
      { name: "Gagret" },
      { name: "Ghumarwin" },
      { name: "Hamirpur" },
      { name: "Jawala Mukhi" },
      { name: "Jogindarnagar" },
      { name: "Jubbal" },
      { name: "Jutogh" },
      { name: "Kalka" },
      { name: "Kangar" },
      { name: "Kangra" },
      { name: "Kasauli" },
      { name: "Kinnaur" },
      { name: "Kotkhai" },
      { name: "Kotla" },
      { name: "Kulu" },
      { name: "Kyelang" },
      { name: "Lahul and Spiti" },
      { name: "Manali" },
      { name: "Mandi" },
      { name: "Nadaun" },
      { name: "Nagar" },
      { name: "Nagrota" },
      { name: "Nahan" },
      { name: "Nalagarh" },
      { name: "Palampur" },
      { name: "Pandoh" },
      { name: "Paonta Sahib" },
      { name: "Parwanoo" },
      { name: "Rajgarh" },
      { name: "Rampur" },
      { name: "Rohru" },
      { name: "Sabathu" },
      { name: "Santokhgarh" },
      { name: "Sarahan" },
      { name: "Sarka Ghat" },
      { name: "Seoni" },
      { name: "Shimla" },
      { name: "Sirmaur" },
      { name: "Solan" },
      { name: "Sundarnagar" },
      { name: "Theog" },
      { name: "Tira Sujanpur" },
      { name: "Una" },
      { name: "Yol" }
    ],
    "Jammu and Kashmir": [
      { name: "Akhnur" },
      { name: "Anantnag" },
      { name: "Awantipur" },
      { name: "Badgam" },
      { name: "Bandipore" },
      { name: "Bandipura" },
      { name: "Banihal" },
      { name: "Baramula" },
      { name: "Batoti" },
      { name: "Bhadarwah" },
      { name: "Bijbehara" },
      { name: "Bishnah" },
      { name: "Doda" },
      { name: "Gandarbal" },
      { name: "Ganderbal" },
      { name: "Gho Brahmanan de" },
      { name: "Hajan" },
      { name: "Hiranagar" },
      { name: "Jammu" },
      { name: "Jaurian" },
      { name: "Kathua" },
      { name: "Katra" },
      { name: "Khaur" },
      { name: "Kishtwar" },
      { name: "Kud" },
      { name: "Kulgam" },
      { name: "Kupwara" },
      { name: "Ladakh" },
      { name: "Magam" },
      { name: "Nawanshahr" },
      { name: "Noria" },
      { name: "Padam" },
      { name: "Pahlgam" },
      { name: "Parol" },
      { name: "Pattan" },
      { name: "Pulwama" },
      { name: "Punch" },
      { name: "Qazigund" },
      { name: "Rajaori" },
      { name: "Rajauri" },
      { name: "Ramban" },
      { name: "Ramgarh" },
      { name: "Ramnagar" },
      { name: "Riasi" },
      { name: "Samba" },
      { name: "Shupiyan" },
      { name: "Sopur" },
      { name: "Soyibug" },
      { name: "Srinagar" },
      { name: "Sumbal" },
      { name: "Thang" },
      { name: "Thanna Mandi" },
      { name: "Tral" },
      { name: "Tsrar Sharif" },
      { name: "Udhampur" },
      { name: "Uri" }
    ],
    "Jharkhand": [
      { name: "Bagra" },
      { name: "Barka Kana" },
      { name: "Barki Saria" },
      { name: "Barwadih" },
      { name: "Bhojudih" },
      { name: "Bokaro" },
      { name: "Bundu" },
      { name: "Chaibasa" },
      { name: "Chakradharpur" },
      { name: "Chakulia" },
      { name: "Chandil" },
      { name: "Chas" },
      { name: "Chatra" },
      { name: "Chiria" },
      { name: "Daltonganj" },
      { name: "Deogarh" },
      { name: "Dhanbad" },
      { name: "Dhanwar" },
      { name: "Dugda" },
      { name: "Dumka" },
      { name: "Garhwa" },
      { name: "Ghatsila" },
      { name: "Giridih" },
      { name: "Gobindpur" },
      { name: "Godda" },
      { name: "Gomoh" },
      { name: "Gopinathpur" },
      { name: "Gua" },
      { name: "Gumia" },
      { name: "Gumla" },
      { name: "Hazaribag" },
      { name: "Hazaribagh" },
      { name: "Hesla" },
      { name: "Husainabad" },
      { name: "Jagannathpur" },
      { name: "Jamadoba" },
      { name: "Jamshedpur" },
      { name: "Jamtara" },
      { name: "Jasidih" },
      { name: "Jharia" },
      { name: "Jugsalai" },
      { name: "Jumri Tilaiya" },
      { name: "Kalikapur" },
      { name: "Kandra" },
      { name: "Kanke" },
      { name: "Katras" },
      { name: "Kenduadih" },
      { name: "Kharsawan" },
      { name: "Khunti" },
      { name: "Kodarma" },
      { name: "Kuju" },
      { name: "Latehar" },
      { name: "Lohardaga" },
      { name: "Madhupur" },
      { name: "Malkera" },
      { name: "Manoharpur" },
      { name: "Mugma" },
      { name: "Mushabani" },
      { name: "Neturhat" },
      { name: "Nirsa" },
      { name: "Noamundi" },
      { name: "Pakur" },
      { name: "Palamu" },
      { name: "Pashchim Singhbhum" },
      { name: "patamda" },
      { name: "Pathardih" },
      { name: "Purba Singhbhum" },
      { name: "Ramgarh" },
      { name: "Ranchi" },
      { name: "Ray" },
      { name: "Sahibganj" },
      { name: "Saraikela" },
      { name: "Sarubera" },
      { name: "Sijua" },
      { name: "Simdega" },
      { name: "Sini" },
      { name: "Topchanchi" }
    ],
    "Karnataka": [
      { name: "Afzalpur" },
      { name: "Ajjampur" },
      { name: "Aland" },
      { name: "Alnavar" },
      { name: "Alur" },
      { name: "Anekal" },
      { name: "Ankola" },
      { name: "Annigeri" },
      { name: "Arkalgud" },
      { name: "Arsikere" },
      { name: "Athni" },
      { name: "Aurad" },
      { name: "Badami" },
      { name: "Bagalkot" },
      { name: "Bagepalli" },
      { name: "Bail-Hongal" },
      { name: "Ballari" },
      { name: "Ballary" },
      { name: "Banavar" },
      { name: "Bangalore Rural" },
      { name: "Bangalore Urban" },
      { name: "Bangarapet" },
      { name: "Bannur" },
      { name: "Bantval" },
      { name: "Basavakalyan" },
      { name: "Basavana Bagevadi" },
      { name: "Belagavi" },
      { name: "Belluru" },
      { name: "Beltangadi" },
      { name: "Belur" },
      { name: "Bengaluru" },
      { name: "Bhadravati" },
      { name: "Bhalki" },
      { name: "Bhatkal" },
      { name: "Bidar" },
      { name: "Bilgi" },
      { name: "Birur" },
      { name: "Byadgi" },
      { name: "Byndoor" },
      { name: "Canacona" },
      { name: "Challakere" },
      { name: "Chamrajnagar" },
      { name: "Channagiri" },
      { name: "Channapatna" },
      { name: "Channarayapatna" },
      { name: "Chik Ballapur" },
      { name: "Chikkaballapur" },
      { name: "Chikkamagaluru" },
      { name: "Chiknayakanhalli" },
      { name: "Chikodi" },
      { name: "Chincholi" },
      { name: "Chintamani" },
      { name: "Chitapur" },
      { name: "Chitradurga" },
      { name: "Closepet" },
      { name: "Coondapoor" },
      { name: "Dakshina Kannada" },
      { name: "Dandeli" },
      { name: "Davanagere" },
      { name: "Devanhalli" },
      { name: "Dharwad" },
      { name: "Dod Ballapur" },
      { name: "French Rocks" },
      { name: "Gadag" },
      { name: "Gadag-Betageri" },
      { name: "Gajendragarh" },
      { name: "Gangawati" },
      { name: "Gangolli" },
      { name: "Gokak" },
      { name: "Gokarna" },
      { name: "Goribidnur" },
      { name: "Gorur" },
      { name: "Gubbi" },
      { name: "Gudibanda" },
      { name: "Guledagudda" },
      { name: "Gundlup\u0113t" },
      { name: "Gurmatkal" },
      { name: "Hadagalli" },
      { name: "Haliyal" },
      { name: "Hampi" },
      { name: "Hangal" },
      { name: "Harihar" },
      { name: "Harpanahalli" },
      { name: "Hassan" },
      { name: "Haveri" },
      { name: "Heggadadevankote" },
      { name: "Hirekerur" },
      { name: "Hiriyur" },
      { name: "Holalkere" },
      { name: "Hole Narsipur" },
      { name: "Homnabad" },
      { name: "Honavar" },
      { name: "Honnali" },
      { name: "Hosanagara" },
      { name: "Hosangadi" },
      { name: "Hosdurga" },
      { name: "Hoskote" },
      { name: "Hospet" },
      { name: "Hubballi" },
      { name: "Hukeri" },
      { name: "Hungund" },
      { name: "Hunsur" },
      { name: "Ilkal" },
      { name: "Indi" },
      { name: "Jagalur" },
      { name: "Jamkhandi" },
      { name: "Jevargi" },
      { name: "Kadur" },
      { name: "Kalaburgi" },
      { name: "Kalghatgi" },
      { name: "Kampli" },
      { name: "Kankanhalli" },
      { name: "Karkala" },
      { name: "Karwar" },
      { name: "Kavalur" },
      { name: "Kerur" },
      { name: "Khanapur" },
      { name: "Kodagu" },
      { name: "Kodigenahalli" },
      { name: "Kodlipet" },
      { name: "Kolar" },
      { name: "Kollegal" },
      { name: "Konanur" },
      { name: "Konnur" },
      { name: "Koppa" },
      { name: "Koppal" },
      { name: "Koratagere" },
      { name: "Kotturu" },
      { name: "Krishnarajpet" },
      { name: "Kudachi" },
      { name: "Kudligi" },
      { name: "Kumsi" },
      { name: "Kumta" },
      { name: "Kundgol" },
      { name: "Kunigal" },
      { name: "Kurgunta" },
      { name: "Kushalnagar" },
      { name: "Kushtagi" },
      { name: "Lakshmeshwar" },
      { name: "Lingsugur" },
      { name: "Londa" },
      { name: "Maddagiri" },
      { name: "Maddur" },
      { name: "Madikeri" },
      { name: "Magadi" },
      { name: "Mahalingpur" },
      { name: "Malavalli" },
      { name: "Malpe" },
      { name: "Malur" },
      { name: "Mandya" },
      { name: "Mangaluru" },
      { name: "Manipal" },
      { name: "Manvi" },
      { name: "Mayakonda" },
      { name: "Melukote" },
      { name: "Mudbidri" },
      { name: "Muddebihal" },
      { name: "Mudgal" },
      { name: "Mudgere" },
      { name: "Mudhol" },
      { name: "Mulbagal" },
      { name: "Mulgund" },
      { name: "Mulki" },
      { name: "Mundargi" },
      { name: "Mundgod" },
      { name: "Munirabad" },
      { name: "Murudeshwara" },
      { name: "Mysuru" },
      { name: "Nagamangala" },
      { name: "Nanjangud" },
      { name: "Narasimharajapura" },
      { name: "Naregal" },
      { name: "Nargund" },
      { name: "Navalgund" },
      { name: "Nelamangala" },
      { name: "Nyamti" },
      { name: "Pangala" },
      { name: "Pavugada" },
      { name: "Piriyapatna" },
      { name: "Ponnampet" },
      { name: "Puttur" },
      { name: "Rabkavi" },
      { name: "Raichur" },
      { name: "Ramanagara" },
      { name: "Ranibennur" },
      { name: "Raybag" },
      { name: "Robertsonpet" },
      { name: "Ron" },
      { name: "Sadalgi" },
      { name: "Sagar" },
      { name: "Sakleshpur" },
      { name: "Sandur" },
      { name: "Sanivarsante" },
      { name: "Sankeshwar" },
      { name: "Sargur" },
      { name: "Saundatti" },
      { name: "Savanur" },
      { name: "Seram" },
      { name: "Shahabad" },
      { name: "Shahpur" },
      { name: "Shiggaon" },
      { name: "Shikarpur" },
      { name: "Shimoga" },
      { name: "Shirhatti" },
      { name: "Shorapur" },
      { name: "Shrirangapattana" },
      { name: "Siddapur" },
      { name: "Sidlaghatta" },
      { name: "Sindgi" },
      { name: "Sindhnur" },
      { name: "Sira" },
      { name: "Sirsi" },
      { name: "Siruguppa" },
      { name: "Someshwar" },
      { name: "Somvarpet" },
      { name: "Sorab" },
      { name: "Sravana Belgola" },
      { name: "Sringeri" },
      { name: "Srinivaspur" },
      { name: "Sulya" },
      { name: "Suntikoppa" },
      { name: "Talikota" },
      { name: "Tarikere" },
      { name: "Tekkalakote" },
      { name: "Terdal" },
      { name: "Tiptur" },
      { name: "Tirthahalli" },
      { name: "Tirumakudal Narsipur" },
      { name: "Tumakuru" },
      { name: "Turuvekere" },
      { name: "Udupi" },
      { name: "Ullal" },
      { name: "Uttar Kannada" },
      { name: "Vadigenhalli" },
      { name: "Vijayapura" },
      { name: "Virarajendrapet" },
      { name: "Wadi" },
      { name: "Yadgir" },
      { name: "Yelahanka" },
      { name: "Yelandur" },
      { name: "Yelbarga" },
      { name: "Yellapur" }
    ],
    "Kerala": [
      { name: "Adur" },
      { name: "Alappuzha" },
      { name: "Aluva" },
      { name: "Alwaye" },
      { name: "Angamali" },
      { name: "Aroor" },
      { name: "Arukutti" },
      { name: "Attingal" },
      { name: "Avanoor" },
      { name: "Azhikkal" },
      { name: "Badagara" },
      { name: "Beypore" },
      { name: "Changanacheri" },
      { name: "Ch\u0113lakara" },
      { name: "Chengannur" },
      { name: "Cherpulassery" },
      { name: "Cherthala" },
      { name: "Chetwayi" },
      { name: "Chittur" },
      { name: "Cochin" },
      { name: "Dharmadam" },
      { name: "Edakkulam" },
      { name: "Elur" },
      { name: "Erattupetta" },
      { name: "Ernakulam" },
      { name: "Ferokh" },
      { name: "Guruvayur" },
      { name: "Idukki" },
      { name: "Iringal" },
      { name: "Irinjalakuda" },
      { name: "Kadakkavoor" },
      { name: "Kalamassery" },
      { name: "Kalavoor" },
      { name: "Kalpatta" },
      { name: "Kannangad" },
      { name: "Kannavam" },
      { name: "Kannur" },
      { name: "Kasaragod" },
      { name: "Kasaragod District" },
      { name: "Kattanam" },
      { name: "Kayankulam" },
      { name: "Kizhake Chalakudi" },
      { name: "Kodungallur" },
      { name: "Kollam" },
      { name: "Kotamangalam" },
      { name: "Kottayam" },
      { name: "Kovalam" },
      { name: "Kozhikode" },
      { name: "Kumbalam" },
      { name: "Kunnamangalam" },
      { name: "Kunnamkulam" },
      { name: "Kunnumma" },
      { name: "Kutiatodu" },
      { name: "Kuttampuzha" },
      { name: "Lalam" },
      { name: "Mah\u0113" },
      { name: "Malappuram" },
      { name: "Manjeri" },
      { name: "Manj\u0113shvar" },
      { name: "Mannarakkat" },
      { name: "Marayur" },
      { name: "Mattanur" },
      { name: "Mavelikara" },
      { name: "Mavoor" },
      { name: "Muluppilagadu" },
      { name: "Munnar" },
      { name: "Muvattupula" },
      { name: "Muvattupuzha" },
      { name: "Nadapuram" },
      { name: "Naduvannur" },
      { name: "Nedumangad" },
      { name: "Neyyattinkara" },
      { name: "Nil\u0113shwar" },
      { name: "Ottappalam" },
      { name: "Palackattumala" },
      { name: "Palakkad district" },
      { name: "Palghat" },
      { name: "Panamaram" },
      { name: "Pappinissh\u0113ri" },
      { name: "Paravur Tekkumbhagam" },
      { name: "Pariyapuram" },
      { name: "Pathanamthitta" },
      { name: "Pattanamtitta" },
      { name: "Payyannur" },
      { name: "Perumbavoor" },
      { name: "Perumpavur" },
      { name: "Perya" },
      { name: "Piravam" },
      { name: "Ponmana" },
      { name: "Ponnani" },
      { name: "Punalur" },
      { name: "Ramamangalam" },
      { name: "Shertallai" },
      { name: "Sh\u014dranur" },
      { name: "Talipparamba" },
      { name: "Tellicherry" },
      { name: "Thanniyam" },
      { name: "Thiruvananthapuram" },
      { name: "Thrissur" },
      { name: "Thrissur District" },
      { name: "Tirur" },
      { name: "Tiruvalla" },
      { name: "Vaikam" },
      { name: "Varkala" },
      { name: "Vayalar" },
      { name: "Vettur" },
      { name: "Wayanad" }
    ],
    "Ladakh": [
      { name: "Kargil" },
      { name: "Leh" }
    ],
    "Lakshadweep": [
      { name: "Kavaratti" },
      { name: "Lakshadweep" }
    ],
    "Madhya Pradesh": [
      { name: "Agar" },
      { name: "Ajaigarh" },
      { name: "Akodia" },
      { name: "Alampur" },
      { name: "Alirajpur" },
      { name: "Alot" },
      { name: "Amanganj" },
      { name: "Amarkantak" },
      { name: "Amarpatan" },
      { name: "Amarwara" },
      { name: "Ambah" },
      { name: "Amla" },
      { name: "Anjad" },
      { name: "Antri" },
      { name: "Anuppur" },
      { name: "Aron" },
      { name: "Ashoknagar" },
      { name: "Ashta" },
      { name: "Babai" },
      { name: "Badarwas" },
      { name: "Badnawar" },
      { name: "Bag" },
      { name: "Bagli" },
      { name: "Baihar" },
      { name: "Baikunthpur" },
      { name: "Bakshwaho" },
      { name: "Balaghat" },
      { name: "Baldeogarh" },
      { name: "Bamna" },
      { name: "Bamor Kalan" },
      { name: "Bamora" },
      { name: "Banda" },
      { name: "Barela" },
      { name: "Barghat" },
      { name: "Bargi" },
      { name: "Barhi" },
      { name: "Barwani" },
      { name: "Basoda" },
      { name: "Begamganj" },
      { name: "Beohari" },
      { name: "Berasia" },
      { name: "Betma" },
      { name: "Betul" },
      { name: "Betul Bazar" },
      { name: "Bhabhra" },
      { name: "Bhainsdehi" },
      { name: "Bhander" },
      { name: "Bhanpura" },
      { name: "Bhawaniganj" },
      { name: "Bhikangaon" },
      { name: "Bhind" },
      { name: "Bhitarwar" },
      { name: "Bhopal" },
      { name: "Biaora" },
      { name: "Bijawar" },
      { name: "Bijrauni" },
      { name: "Bodri" },
      { name: "Burhanpur" },
      { name: "Burhar" },
      { name: "Chanderi" },
      { name: "Chandia" },
      { name: "Chandla" },
      { name: "Chhatarpur" },
      { name: "Chhindwara" },
      { name: "Chichli" },
      { name: "Chorhat" },
      { name: "Daboh" },
      { name: "Dabra" },
      { name: "Damoh" },
      { name: "Datia" },
      { name: "Deori Khas" },
      { name: "Depalpur" },
      { name: "Dewas" },
      { name: "Dhamnod" },
      { name: "Dhana" },
      { name: "Dhar" },
      { name: "Dharampuri" },
      { name: "Dindori" },
      { name: "Etawa" },
      { name: "Gadarwara" },
      { name: "Garha Brahman" },
      { name: "Garhakota" },
      { name: "Gautampura" },
      { name: "Ghansor" },
      { name: "Gogapur" },
      { name: "Gohadi" },
      { name: "Govindgarh" },
      { name: "Guna" },
      { name: "Gurh" },
      { name: "Gwalior" },
      { name: "Harda" },
      { name: "Harda Khas" },
      { name: "Harpalpur" },
      { name: "Harrai" },
      { name: "Harsud" },
      { name: "Hatod" },
      { name: "Hatta" },
      { name: "Hindoria" },
      { name: "Hoshangabad" },
      { name: "Iawar" },
      { name: "Ichhawar" },
      { name: "Iklehra" },
      { name: "Indore" },
      { name: "Isagarh" },
      { name: "Itarsi" },
      { name: "Jabalpur" },
      { name: "Jaisinghnagar" },
      { name: "Jaithari" },
      { name: "Jamai" },
      { name: "Jaora" },
      { name: "Jatara" },
      { name: "Jawad" },
      { name: "Jhabua" },
      { name: "Jiran" },
      { name: "Jobat" },
      { name: "Kailaras" },
      { name: "Kaimori" },
      { name: "Kannod" },
      { name: "Kareli" },
      { name: "Karera" },
      { name: "Karrapur" },
      { name: "Kasrawad" },
      { name: "Katangi" },
      { name: "Katni" },
      { name: "Khachrod" },
      { name: "Khailar" },
      { name: "Khajuraho Group of Monuments" },
      { name: "Khamaria" },
      { name: "Khandwa" },
      { name: "Khandwa district" },
      { name: "Khargapur" },
      { name: "Khargone" },
      { name: "Khategaon" },
      { name: "Khilchipur" },
      { name: "Khirkiyan" },
      { name: "Khujner" },
      { name: "Khurai" },
      { name: "Kolaras" },
      { name: "Korwai" },
      { name: "Kotar" },
      { name: "Kothi" },
      { name: "Kotma" },
      { name: "Kotwa" },
      { name: "Kukshi" },
      { name: "Kumbhraj" },
      { name: "Lahar" },
      { name: "Lakhnadon" },
      { name: "Leteri" },
      { name: "Lodhikheda" },
      { name: "Machalpur" },
      { name: "Madhogarh" },
      { name: "Maheshwar" },
      { name: "Mahgawan" },
      { name: "Maihar" },
      { name: "Majholi" },
      { name: "Maksi" },
      { name: "Malhargarh" },
      { name: "Manasa" },
      { name: "Manawar" },
      { name: "Mandideep" },
      { name: "Mandla" },
      { name: "Mandleshwar" },
      { name: "Mandsaur" },
      { name: "Mangawan" },
      { name: "Manpur" },
      { name: "Mau" },
      { name: "Mauganj" },
      { name: "Mihona" },
      { name: "Mohgaon" },
      { name: "Morar" },
      { name: "Morena" },
      { name: "Multai" },
      { name: "Mundi" },
      { name: "Mungaoli" },
      { name: "Murwara" },
      { name: "Nagda" },
      { name: "Nagod" },
      { name: "Naigarhi" },
      { name: "Nainpur" },
      { name: "Namli" },
      { name: "Naraini" },
      { name: "Narayangarh" },
      { name: "Narsimhapur" },
      { name: "Narsinghgarh" },
      { name: "Narwar" },
      { name: "Nasrullahganj" },
      { name: "Neemuch" },
      { name: "Nepanagar" },
      { name: "Orchha" },
      { name: "Pachmarhi" },
      { name: "Palera" },
      { name: "Pali" },
      { name: "Panagar" },
      { name: "Panara" },
      { name: "Pandhana" },
      { name: "Pandhurna" },
      { name: "Panna" },
      { name: "Pansemal" },
      { name: "Parasia" },
      { name: "Patan" },
      { name: "Patharia" },
      { name: "Pawai" },
      { name: "Petlawad" },
      { name: "Piploda" },
      { name: "Pithampur" },
      { name: "Porsa" },
      { name: "Punasa" },
      { name: "Raghogarh" },
      { name: "Rahatgarh" },
      { name: "Raisen" },
      { name: "Rajgarh" },
      { name: "Rajnagar" },
      { name: "Rajpur" },
      { name: "Rampura" },
      { name: "Ranapur" },
      { name: "Ratangarh" },
      { name: "Ratlam" },
      { name: "Rehli" },
      { name: "Rehti" },
      { name: "Rewa" },
      { name: "Sabalgarh" },
      { name: "Sagar" },
      { name: "Sailana" },
      { name: "Sanawad" },
      { name: "Sanchi" },
      { name: "Sanwer" },
      { name: "Sarangpur" },
      { name: "Satna" },
      { name: "Satwas" },
      { name: "Saugor" },
      { name: "Sausar" },
      { name: "Sehore" },
      { name: "Sendhwa" },
      { name: "Seondha" },
      { name: "Seoni" },
      { name: "Seoni Malwa" },
      { name: "Shahdol" },
      { name: "Shahgarh" },
      { name: "Shahpur" },
      { name: "Shahpura" },
      { name: "Shajapur" },
      { name: "Shamgarh" },
      { name: "Sheopur" },
      { name: "Shivpuri" },
      { name: "Shujalpur" },
      { name: "Sidhi" },
      { name: "Sihora" },
      { name: "Simaria" },
      { name: "Singoli" },
      { name: "Singrauli" },
      { name: "Sirmaur" },
      { name: "Sironj" },
      { name: "Sitamau" },
      { name: "Sohagi" },
      { name: "Sohagpur" },
      { name: "Sultanpur" },
      { name: "Susner" },
      { name: "Tal" },
      { name: "Talen" },
      { name: "Tarana" },
      { name: "Tekanpur" },
      { name: "Tendukheda" },
      { name: "Teonthar" },
      { name: "Thandla" },
      { name: "Tikamgarh" },
      { name: "Tirodi" },
      { name: "Udaipura" },
      { name: "Ujjain" },
      { name: "Ukwa" },
      { name: "Umaria" },
      { name: "Umaria District" },
      { name: "Umri" },
      { name: "Unhel" },
      { name: "Vidisha" },
      { name: "Waraseoni" }
    ],
    "Maharashtra": [
      { name: "Achalpur" },
      { name: "Adawad" },
      { name: "Agar Panchaitan" },
      { name: "Aheri" },
      { name: "Ahiri" },
      { name: "Ahmadnagar" },
      { name: "Ahmadpur" },
      { name: "Ahmednagar" },
      { name: "Airoli" },
      { name: "Ajra" },
      { name: "Akalkot" },
      { name: "Akkalkot" },
      { name: "Akluj" },
      { name: "Akola" },
      { name: "Akolner" },
      { name: "Akot" },
      { name: "Akrani" },
      { name: "Alandi" },
      { name: "Ale" },
      { name: "Alibag" },
      { name: "Alkuti" },
      { name: "Allapalli" },
      { name: "Amalner" },
      { name: "Amarnath" },
      { name: "Ambad" },
      { name: "Ambajogai" },
      { name: "Ambarnath" },
      { name: "Ambegaon" },
      { name: "Amgaon" },
      { name: "Amravati" },
      { name: "Amravati Division" },
      { name: "Andheri" },
      { name: "Andura" },
      { name: "Anjangaon" },
      { name: "Anjarle" },
      { name: "Anshing" },
      { name: "Arag" },
      { name: "Arangaon" },
      { name: "Ardhapur" },
      { name: "Argaon" },
      { name: "Artist Village" },
      { name: "Arvi" },
      { name: "Ashta" },
      { name: "Ashti" },
      { name: "Asoda" },
      { name: "Assaye" },
      { name: "Astagaon" },
      { name: "Aundh Satara" },
      { name: "Aurangabad" },
      { name: "Ausa" },
      { name: "Badlapur" },
      { name: "Badnapur" },
      { name: "Badnera" },
      { name: "Bagewadi" },
      { name: "Balapur" },
      { name: "Balapur Akola district" },
      { name: "Ballalpur" },
      { name: "Ballard Estate" },
      { name: "Ballarpur" },
      { name: "Banda Maharashtra" },
      { name: "Bandra" },
      { name: "Baner" },
      { name: "Bankot" },
      { name: "Baramati" },
      { name: "Barsi" },
      { name: "Basmat" },
      { name: "Basmath" },
      { name: "Bavdhan" },
      { name: "Bawanbir" },
      { name: "Beed" },
      { name: "Bhadgaon Maharashtra" },
      { name: "Bhandara" },
      { name: "Bhandardara" },
      { name: "Bhandup" },
      { name: "Bhayandar" },
      { name: "Bhigvan" },
      { name: "Bhiwandi" },
      { name: "Bhiwapur" },
      { name: "Bhokar" },
      { name: "Bhokardan" },
      { name: "Bhoom" },
      { name: "Bhor" },
      { name: "Bhudgaon" },
      { name: "Bhugaon" },
      { name: "Bhum" },
      { name: "Bhusaval" },
      { name: "Bhusawal" },
      { name: "Bid" },
      { name: "Bijur" },
      { name: "Bilashi" },
      { name: "Biloli" },
      { name: "Boisar" },
      { name: "Borgaon Manju" },
      { name: "Borivali" },
      { name: "Borivli" },
      { name: "Brahmapuri" },
      { name: "Breach Candy" },
      { name: "Buldana" },
      { name: "Buldhana" },
      { name: "Byculla" },
      { name: "Chakan" },
      { name: "Chakur" },
      { name: "Chalisgaon" },
      { name: "Chanda" },
      { name: "Chandgad" },
      { name: "Chandor" },
      { name: "Chandrapur" },
      { name: "Chandur" },
      { name: "Chandur Bazar" },
      { name: "Chausala" },
      { name: "Chembur" },
      { name: "Chicholi" },
      { name: "Chichondi Patil" },
      { name: "Chikhli (Buldhana)" },
      { name: "Chikhli (Jalna)" },
      { name: "Chimur" },
      { name: "Chinchani" },
      { name: "Chinchpokli" },
      { name: "Chiplun" },
      { name: "Chopda" },
      { name: "Colaba" },
      { name: "Dabhol" },
      { name: "Daddi" },
      { name: "Dahanu" },
      { name: "Dahivel" },
      { name: "Dapoli" },
      { name: "Darwha" },
      { name: "Daryapur" },
      { name: "Dattapur" },
      { name: "Daulatabad" },
      { name: "Daund" },
      { name: "Deccan Gymkhana" },
      { name: "Deglur" },
      { name: "Dehu" },
      { name: "Deolali" },
      { name: "Deolapar" },
      { name: "Deoli" },
      { name: "Deoni" },
      { name: "Deulgaon Raja" },
      { name: "Devrukh" },
      { name: "Dharangaon" },
      { name: "Dharavi" },
      { name: "Dharmabad" },
      { name: "Dharur" },
      { name: "Dhawalpuri" },
      { name: "Dhule" },
      { name: "Dhulia" },
      { name: "Dighori" },
      { name: "Diglur" },
      { name: "Digras" },
      { name: "Dindori Maharashtra" },
      { name: "Diveagar" },
      { name: "Dombivli" },
      { name: "Dondaicha" },
      { name: "Dongri" },
      { name: "Dudhani" },
      { name: "Durgapur" },
      { name: "Durgapur Chandrapur" },
      { name: "Erandol" },
      { name: "Faizpur" },
      { name: "Fort" },
      { name: "Gadchiroli" },
      { name: "Gadhinglaj" },
      { name: "Gangakher" },
      { name: "Gangapur" },
      { name: "Ganpatipule" },
      { name: "Gevrai" },
      { name: "Ghargaon" },
      { name: "Ghatanji" },
      { name: "Ghatkopar" },
      { name: "Ghoti Budrukh" },
      { name: "Ghugus" },
      { name: "Girgaon" },
      { name: "Gondia" },
      { name: "Gondiya" },
      { name: "Gorai" },
      { name: "Goregaon" },
      { name: "Guhagar" },
      { name: "Hadapsar Pune" },
      { name: "Hadgaon" },
      { name: "Halkarni" },
      { name: "Harangul" },
      { name: "Harnai" },
      { name: "Helwak" },
      { name: "Hinganghat" },
      { name: "Hingoli" },
      { name: "Hirapur" },
      { name: "Hirapur Hamesha" },
      { name: "Hotgi" },
      { name: "Ichalkaranji" },
      { name: "Igatpuri" },
      { name: "Indapur" },
      { name: "Jaisingpur" },
      { name: "Jaitapur" },
      { name: "Jakhangaon" },
      { name: "Jalgaon" },
      { name: "Jalgaon Jamod" },
      { name: "Jalkot" },
      { name: "Jalna" },
      { name: "Jamkhed" },
      { name: "Jamod" },
      { name: "Janephal" },
      { name: "Jaoli" },
      { name: "Jat Sangli" },
      { name: "Jategaon" },
      { name: "Jawhar" },
      { name: "Jaysingpur" },
      { name: "Jejuri" },
      { name: "Jintur" },
      { name: "Jogeshwari" },
      { name: "Juhu" },
      { name: "Junnar" },
      { name: "Kachurwahi" },
      { name: "Kadegaon" },
      { name: "Kadus" },
      { name: "Kagal" },
      { name: "Kaij" },
      { name: "Kalamb" },
      { name: "Kalamb Osmanabad" },
      { name: "Kalamboli" },
      { name: "Kalamnuri" },
      { name: "Kalas" },
      { name: "Kali(DK)" },
      { name: "Kalmeshwar" },
      { name: "Kalundri" },
      { name: "Kalyan" },
      { name: "Kalyani Nagar" },
      { name: "Kamargaon" },
      { name: "Kamatgi" },
      { name: "Kamptee" },
      { name: "Kamthi" },
      { name: "Kandri" },
      { name: "Kankauli" },
      { name: "Kankavli" },
      { name: "Kannad" },
      { name: "Karad" },
      { name: "Karajagi" },
      { name: "Karanja" },
      { name: "Karanja Lad" },
      { name: "Karjat" },
      { name: "Karkamb" },
      { name: "Karmala" },
      { name: "Kasara" },
      { name: "Kasoda" },
      { name: "Kati" },
      { name: "Katol" },
      { name: "Katral" },
      { name: "Khadki" },
      { name: "Khalapur" },
      { name: "Khallar" },
      { name: "Khamgaon" },
      { name: "Khanapur" },
      { name: "Khandala" },
      { name: "Khangaon" },
      { name: "Khapa" },
      { name: "Kharakvasla" },
      { name: "Kharda" },
      { name: "Kharghar" },
      { name: "Kharsundi" },
      { name: "Khed" },
      { name: "Khede" },
      { name: "Khetia" },
      { name: "Khoni" },
      { name: "Khopoli" },
      { name: "Khuldabad" },
      { name: "Kinwat" },
      { name: "Kodoli" },
      { name: "Kolhapur" },
      { name: "Kondalwadi" },
      { name: "Kondhali" },
      { name: "Kopar Khairane" },
      { name: "Kopargaon" },
      { name: "Kopela" },
      { name: "Koradi" },
      { name: "Koregaon" },
      { name: "Koynanagar" },
      { name: "Kudal" },
      { name: "Kuhi" },
      { name: "Kurandvad" },
      { name: "Kurankhed" },
      { name: "Kurduvadi" },
      { name: "Kusumba" },
      { name: "Lakhandur" },
      { name: "Lanja" },
      { name: "Lasalgaon" },
      { name: "Latur" },
      { name: "Lavasa" },
      { name: "Lohogaon" },
      { name: "Lonar" },
      { name: "Lonavla" },
      { name: "Mahabaleshwar" },
      { name: "Mahad" },
      { name: "Mahape" },
      { name: "Mahim" },
      { name: "Maindargi" },
      { name: "Majalgaon" },
      { name: "Makhjan" },
      { name: "Malabar Hill" },
      { name: "Malad" },
      { name: "Malegaon" },
      { name: "Malkapur" },
      { name: "Malvan" },
      { name: "Manchar" },
      { name: "Mandangad" },
      { name: "Mandhal" },
      { name: "Mandwa" },
      { name: "Mangaon" },
      { name: "Mangrul Pir" },
      { name: "Manjlegaon" },
      { name: "Mankeshwar" },
      { name: "Mankhurd" },
      { name: "Manmad" },
      { name: "Manor" },
      { name: "Mansar" },
      { name: "Manwat" },
      { name: "Manwath" },
      { name: "Maregaon" },
      { name: "Mastiholi" },
      { name: "Masur India" },
      { name: "Matheran" },
      { name: "Matunga" },
      { name: "Mazagaon" },
      { name: "Mehekar" },
      { name: "Mehergaon" },
      { name: "Mehkar" },
      { name: "Mhasla" },
      { name: "Mhasvad" },
      { name: "Miraj" },
      { name: "Mohadi" },
      { name: "Mohol" },
      { name: "Mohpa" },
      { name: "Mokhada taluka" },
      { name: "Mora Maharashtra" },
      { name: "Moram" },
      { name: "Morsi" },
      { name: "Mowad" },
      { name: "Mudkhed" },
      { name: "Mukher" },
      { name: "Mul" },
      { name: "Mulher" },
      { name: "Mulund" },
      { name: "Mumbai" },
      { name: "Mumbai Suburban" },
      { name: "Murbad" },
      { name: "Murgud" },
      { name: "Murtajapur" },
      { name: "Murud (Raigad)" },
      { name: "Murud (Ratnagiri)" },
      { name: "Murum" },
      { name: "Nadgaon" },
      { name: "Nagapur" },
      { name: "Nagothana" },
      { name: "Nagpur" },
      { name: "Nagpur Division" },
      { name: "Nala Sopara" },
      { name: "Naldurg" },
      { name: "Nalegaon" },
      { name: "Nampur" },
      { name: "Nanded" },
      { name: "Nandgaon" },
      { name: "Nandnee" },
      { name: "Nandura" },
      { name: "Nandura Buzurg" },
      { name: "Nandurbar" },
      { name: "Narayangaon" },
      { name: "Nardana" },
      { name: "Nariman Point" },
      { name: "Narkhed" },
      { name: "Nashik" },
      { name: "Nashik Division" },
      { name: "Navapur" },
      { name: "Navi Mumbai" },
      { name: "Neral" },
      { name: "Nerur" },
      { name: "Nevasa" },
      { name: "Nighoj" },
      { name: "Nilanga" },
      { name: "Nipani" },
      { name: "Niphad" },
      { name: "Nira Narsingpur" },
      { name: "Osmanabad" },
      { name: "Ozar" },
      { name: "Pabal" },
      { name: "Pachora" },
      { name: "Pahur Maharashtra" },
      { name: "Paithan" },
      { name: "Palghar" },
      { name: "Pali Raigad" },
      { name: "Palso" },
      { name: "Panchgani" },
      { name: "Pandharpur" },
      { name: "Pandhurli" },
      { name: "Panhala" },
      { name: "Panvel" },
      { name: "Parbhani" },
      { name: "Parel" },
      { name: "Parli Vaijnath" },
      { name: "Parner" },
      { name: "Parola" },
      { name: "Parseoni" },
      { name: "Partur" },
      { name: "Patan" },
      { name: "Pathardi" },
      { name: "Pathri" },
      { name: "Patur" },
      { name: "Paturda" },
      { name: "Paud" },
      { name: "Pauni" },
      { name: "Pawni" },
      { name: "Pedgaon" },
      { name: "Peint" },
      { name: "Pen" },
      { name: "Phaltan" },
      { name: "Phulambri" },
      { name: "Piliv" },
      { name: "Pimpalgaon Baswant" },
      { name: "Pimpalgaon Raja" },
      { name: "Pimpri" },
      { name: "Pimpri-Chinchwad" },
      { name: "Pipri" },
      { name: "Powai" },
      { name: "Prabhadevi" },
      { name: "Prakasha" },
      { name: "Pulgaon" },
      { name: "Pune" },
      { name: "Pune Division" },
      { name: "Puntamba" },
      { name: "Pural" },
      { name: "Purna" },
      { name: "Pusad" },
      { name: "Radhanagari" },
      { name: "Rahata" },
      { name: "Rahimatpur" },
      { name: "Rahuri" },
      { name: "Raigarh" },
      { name: "Raireshwar" },
      { name: "Rajapur" },
      { name: "Rajgurunagar" },
      { name: "Rajur" },
      { name: "Rajura" },
      { name: "Ralegaon" },
      { name: "Ramewadi" },
      { name: "Ramtek" },
      { name: "Ratnagiri" },
      { name: "Raver" },
      { name: "Renapur" },
      { name: "Renavi" },
      { name: "Revadanda" },
      { name: "Revdanda" },
      { name: "Risod" },
      { name: "Roha" },
      { name: "Sailu" },
      { name: "Sakol" },
      { name: "Sakoli" },
      { name: "Sakri" },
      { name: "Samudrapur" },
      { name: "Sangameshwar" },
      { name: "Sangamner" },
      { name: "Sangli" },
      { name: "Sangola" },
      { name: "Sangole" },
      { name: "Sangrampur Maharashtra" },
      { name: "Saoli" },
      { name: "Saoner" },
      { name: "Sarangkheda" },
      { name: "Sasvad" },
      { name: "Saswad" },
      { name: "Satana" },
      { name: "Satara" },
      { name: "Satara Division" },
      { name: "Satpati" },
      { name: "Savantvadi" },
      { name: "Savda" },
      { name: "Savlaj" },
      { name: "Sawantvadi" },
      { name: "Selu" },
      { name: "Sevagram" },
      { name: "Sewri" },
      { name: "Shahada" },
      { name: "Shahapur" },
      { name: "Shedbal" },
      { name: "Shegaon" },
      { name: "Shevgaon" },
      { name: "Shikrapur" },
      { name: "Shiraguppi" },
      { name: "Shirala" },
      { name: "Shirdi" },
      { name: "Shirgaon" },
      { name: "Shirol" },
      { name: "Shirpur" },
      { name: "Shirud" },
      { name: "Shirwal" },
      { name: "Shivaji Nagar" },
      { name: "Shrigonda" },
      { name: "Sillod" },
      { name: "Sindewahi" },
      { name: "Sindhudurg" },
      { name: "Sindi" },
      { name: "Sindkheda" },
      { name: "Sinnar" },
      { name: "Sion Mumbai" },
      { name: "Sironcha" },
      { name: "Sirur" },
      { name: "Sivala East Godavari district" },
      { name: "Solapur" },
      { name: "Sonala" },
      { name: "Sonegaon" },
      { name: "Songir" },
      { name: "Sonvad" },
      { name: "Soygaon" },
      { name: "Srivardhan" },
      { name: "Surgana" },
      { name: "Taklibhan" },
      { name: "Talbid" },
      { name: "Talegaon Dabhade" },
      { name: "Talegaon Dhamdhere" },
      { name: "Taloda" },
      { name: "Talode" },
      { name: "Tarapur" },
      { name: "Tardeo" },
      { name: "Tasgaon" },
      { name: "Telhara" },
      { name: "Thalner" },
      { name: "Thane" },
      { name: "Trimbak" },
      { name: "Trombay" },
      { name: "Tuljapur" },
      { name: "Tumsar" },
      { name: "Udgir" },
      { name: "Ulhasnagar" },
      { name: "Umarga" },
      { name: "Umarkhed" },
      { name: "Umred" },
      { name: "Uran" },
      { name: "Uruli Kanchan" },
      { name: "Vada" },
      { name: "Vadgaon" },
      { name: "Vadner" },
      { name: "Vaijapur" },
      { name: "Vairag" },
      { name: "Valsang" },
      { name: "Vangaon" },
      { name: "Varangaon" },
      { name: "Vashi" },
      { name: "Vasind" },
      { name: "Vatul" },
      { name: "Velas Maharashtra" },
      { name: "Velneshwar" },
      { name: "Vengurla" },
      { name: "Vijaydurg" },
      { name: "Vikhroli" },
      { name: "Vile Parle" },
      { name: "Vinchur" },
      { name: "Virar" },
      { name: "Vita Maharashtra" },
      { name: "Vite" },
      { name: "Wadala" },
      { name: "Wadgaon" },
      { name: "Wadner" },
      { name: "Wadwani" },
      { name: "Wagholi" },
      { name: "Wai" },
      { name: "Wakad" },
      { name: "Walgaon" },
      { name: "Walki" },
      { name: "Wani" },
      { name: "Wardha" },
      { name: "Warora" },
      { name: "Warud" },
      { name: "Washim" },
      { name: "Worli" },
      { name: "Yaval" },
      { name: "Yavatmal" },
      { name: "Yeola" }
    ],
    "Manipur": [
      { name: "Bishnupur" },
      { name: "Churachandpur" },
      { name: "Imphal" },
      { name: "Kakching" },
      { name: "Mayang Imphal" },
      { name: "Moirang" },
      { name: "Phek" },
      { name: "Senapati" },
      { name: "Tamenglong" },
      { name: "Thoubal" },
      { name: "Ukhrul" },
      { name: "Wangjing" },
      { name: "Yairipok" }
    ],
    "Meghalaya": [
      { name: "Cherrapunji" },
      { name: "East Garo Hills" },
      { name: "East Jaintia Hills" },
      { name: "East Khasi Hills" },
      { name: "Mairang" },
      { name: "Mankachar" },
      { name: "Nongpoh" },
      { name: "Nongstoin" },
      { name: "North Garo Hills" },
      { name: "Ri-Bhoi" },
      { name: "Shillong" },
      { name: "South Garo Hills" },
      { name: "South West Garo Hills" },
      { name: "South West Khasi Hills" },
      { name: "Tura" },
      { name: "West Garo Hills" },
      { name: "West Jaintia Hills" },
      { name: "West Khasi Hills" }
    ],
    "Mizoram": [
      { name: "Aizawl" },
      { name: "Champhai" },
      { name: "Darlawn" },
      { name: "Khawhai" },
      { name: "Kolasib" },
      { name: "Kolasib district" },
      { name: "Lawngtlai" },
      { name: "Lunglei" },
      { name: "Mamit" },
      { name: "North Vanlaiphai" },
      { name: "Saiha" },
      { name: "Sairang" },
      { name: "Saitlaw" },
      { name: "Serchhip" },
      { name: "Thenzawl" }
    ],
    "Nagaland": [
      { name: "Dimapur" },
      { name: "Kohima" },
      { name: "Mokokchung" },
      { name: "Mon" },
      { name: "Peren" },
      { name: "Phek" },
      { name: "Tuensang" },
      { name: "Tuensang District" },
      { name: "Wokha" },
      { name: "Zunheboto" }
    ],
    "Odisha": [
      { name: "Angul" },
      { name: "Angul District" },
      { name: "Asika" },
      { name: "Athagarh" },
      { name: "Bada Barabil" },
      { name: "Balangir" },
      { name: "Balasore" },
      { name: "Baleshwar" },
      { name: "Balimila" },
      { name: "Balugaon" },
      { name: "Banapur" },
      { name: "Banki" },
      { name: "Banposh" },
      { name: "Baragarh" },
      { name: "Barbil" },
      { name: "Bargarh" },
      { name: "Barpali" },
      { name: "Basudebpur" },
      { name: "Baud" },
      { name: "Baudh" },
      { name: "Belaguntha" },
      { name: "Bhadrak" },
      { name: "Bhadrakh" },
      { name: "Bhanjanagar" },
      { name: "Bhawanipatna" },
      { name: "Bhuban" },
      { name: "Bhubaneswar" },
      { name: "Binka" },
      { name: "Birmitrapur" },
      { name: "Bolanikhodan" },
      { name: "Brahmapur" },
      { name: "Brajarajnagar" },
      { name: "Buguda" },
      { name: "Burla" },
      { name: "Champua" },
      { name: "Chandbali" },
      { name: "Chatrapur" },
      { name: "Chikitigarh" },
      { name: "Chittarkonda" },
      { name: "Cuttack" },
      { name: "Daitari" },
      { name: "Deogarh" },
      { name: "Dhenkanal" },
      { name: "Digapahandi" },
      { name: "Gajapati" },
      { name: "Ganjam" },
      { name: "Gopalpur" },
      { name: "Gudari" },
      { name: "Gunupur" },
      { name: "Hinjilikatu" },
      { name: "Hirakud" },
      { name: "Jagatsinghapur" },
      { name: "Jagatsinghpur" },
      { name: "Jajpur" },
      { name: "Jaleshwar" },
      { name: "Jatani" },
      { name: "Jeypore" },
      { name: "Jharsuguda" },
      { name: "Jharsuguda District" },
      { name: "Kaintragarh" },
      { name: "Kalahandi" },
      { name: "Kamakhyanagar" },
      { name: "Kandhamal" },
      { name: "Kantabanji" },
      { name: "Kantilo" },
      { name: "Kendrapara" },
      { name: "Kendraparha" },
      { name: "Kendujhar" },
      { name: "Kesinga" },
      { name: "Khallikot" },
      { name: "Kharhial" },
      { name: "Khordha" },
      { name: "Khurda" },
      { name: "Kiri Buru" },
      { name: "Kodala" },
      { name: "Konarka" },
      { name: "Koraput" },
      { name: "Kuchaiburi" },
      { name: "Kuchinda" },
      { name: "Malakanagiri" },
      { name: "Malkangiri" },
      { name: "Mayurbhanj" },
      { name: "Nabarangpur" },
      { name: "Nayagarh" },
      { name: "Nayagarh District" },
      { name: "Nilgiri" },
      { name: "Nimaparha" },
      { name: "Nowrangapur" },
      { name: "Nuapada" },
      { name: "Padampur" },
      { name: "Paradip Garh" },
      { name: "Patamundai" },
      { name: "Patnagarh" },
      { name: "Phulbani" },
      { name: "Pipili" },
      { name: "Polasara" },
      { name: "Puri" },
      { name: "Purushottampur" },
      { name: "Rambha" },
      { name: "Raurkela" },
      { name: "Rayagada" },
      { name: "Remuna" },
      { name: "Rengali" },
      { name: "Sambalpur" },
      { name: "Sonepur" },
      { name: "Sorada" },
      { name: "Soro" },
      { name: "Subarnapur" },
      { name: "Sundargarh" },
      { name: "Talcher" },
      { name: "Tarabha" },
      { name: "Titlagarh" },
      { name: "Udayagiri" }
    ],
    "Puducherry": [
      { name: "Karaikal" },
      { name: "Mahe" },
      { name: "Puducherry" },
      { name: "Yanam" }
    ],
    "Punjab": [
      { name: "Abohar" },
      { name: "Adampur" },
      { name: "Ajitgarh" },
      { name: "Ajnala" },
      { name: "Akalgarh" },
      { name: "Alawalpur" },
      { name: "Amloh" },
      { name: "Amritsar" },
      { name: "Anandpur Sahib" },
      { name: "Badhni Kalan" },
      { name: "Bagha Purana" },
      { name: "Bakloh" },
      { name: "Balachor" },
      { name: "Banga" },
      { name: "Banur" },
      { name: "Barnala" },
      { name: "Batala" },
      { name: "Begowal" },
      { name: "Bhadaur" },
      { name: "Bhatinda" },
      { name: "Bhawanigarh" },
      { name: "Bhikhi" },
      { name: "Bhogpur" },
      { name: "Bholath" },
      { name: "Budhlada" },
      { name: "Chima" },
      { name: "Dasuya" },
      { name: "Dera Baba Nanak" },
      { name: "Dera Bassi" },
      { name: "Dhanaula" },
      { name: "Dhariwal" },
      { name: "Dhilwan" },
      { name: "Dhudi" },
      { name: "Dhuri" },
      { name: "Dina Nagar" },
      { name: "Dirba" },
      { name: "Doraha" },
      { name: "Faridkot" },
      { name: "Fatehgarh Churian" },
      { name: "Fatehgarh Sahib" },
      { name: "Fazilka" },
      { name: "Firozpur" },
      { name: "Firozpur District" },
      { name: "Gardhiwala" },
      { name: "Garhshankar" },
      { name: "Ghanaur" },
      { name: "Giddarbaha" },
      { name: "Gurdaspur" },
      { name: "Guru Har Sahai" },
      { name: "Hajipur" },
      { name: "Hariana" },
      { name: "Hoshiarpur" },
      { name: "Ishanpur" },
      { name: "Jagraon" },
      { name: "Jaito" },
      { name: "Jalalabad" },
      { name: "Jalandhar" },
      { name: "Jandiala" },
      { name: "Jandiala Guru" },
      { name: "Kalanaur" },
      { name: "Kapurthala" },
      { name: "Kartarpur" },
      { name: "Khamanon" },
      { name: "Khanna" },
      { name: "Kharar" },
      { name: "Khemkaran" },
      { name: "Kot Isa Khan" },
      { name: "Kotkapura" },
      { name: "Laungowal" },
      { name: "Ludhiana" },
      { name: "Machhiwara" },
      { name: "Majitha" },
      { name: "Makhu" },
      { name: "Malaut" },
      { name: "Malerkotla" },
      { name: "Mansa" },
      { name: "Maur Mandi" },
      { name: "Moga" },
      { name: "Mohali" },
      { name: "Morinda" },
      { name: "Mukerian" },
      { name: "Nabha" },
      { name: "Nakodar" },
      { name: "Nangal" },
      { name: "Nawanshahr" },
      { name: "Nurmahal" },
      { name: "Nurpur Kalan" },
      { name: "Pathankot" },
      { name: "Patiala" },
      { name: "Patti" },
      { name: "Phagwara" },
      { name: "Phillaur" },
      { name: "Qadian" },
      { name: "Rahon" },
      { name: "Raikot" },
      { name: "Rajasansi" },
      { name: "Rajpura" },
      { name: "Ram Das" },
      { name: "Rampura" },
      { name: "Rupnagar" },
      { name: "Samrala" },
      { name: "Sanaur" },
      { name: "Sangrur" },
      { name: "Sardulgarh" },
      { name: "Shahid Bhagat Singh Nagar" },
      { name: "Shahkot" },
      { name: "Sham Churasi" },
      { name: "Sirhind-Fategarh" },
      { name: "Sri Muktsar Sahib" },
      { name: "Sultanpur Lodhi" },
      { name: "Sunam" },
      { name: "Talwandi Bhai" },
      { name: "Talwara" },
      { name: "Tarn Taran Sahib" },
      { name: "Zira" }
    ],
    "Rajasthan": [
      { name: "Abhaneri" },
      { name: "Abu" },
      { name: "Abu Road" },
      { name: "Ajmer" },
      { name: "Aklera" },
      { name: "Alwar" },
      { name: "Amet" },
      { name: "Anta" },
      { name: "Anupgarh" },
      { name: "Asind" },
      { name: "Bagar" },
      { name: "Bakani" },
      { name: "Bali" },
      { name: "Balotra" },
      { name: "Bandikui" },
      { name: "Banswara" },
      { name: "Baran" },
      { name: "Bari" },
      { name: "Bari Sadri" },
      { name: "Barmer" },
      { name: "Basi" },
      { name: "Basni" },
      { name: "Baswa" },
      { name: "Bayana" },
      { name: "Beawar" },
      { name: "Begun" },
      { name: "Behror" },
      { name: "Bhadasar" },
      { name: "Bhadra" },
      { name: "Bharatpur" },
      { name: "Bhasawar" },
      { name: "Bhilwara" },
      { name: "Bhindar" },
      { name: "Bhinmal" },
      { name: "Bhiwadi" },
      { name: "Bhuma" },
      { name: "Bikaner" },
      { name: "Bilara" },
      { name: "Bissau" },
      { name: "Borkhera" },
      { name: "Bundi" },
      { name: "Chaksu" },
      { name: "Chechat" },
      { name: "Chhabra" },
      { name: "Chhapar" },
      { name: "Chhoti Sadri" },
      { name: "Chidawa" },
      { name: "Chittaurgarh" },
      { name: "Churu" },
      { name: "Dariba" },
      { name: "Dausa" },
      { name: "Deoli" },
      { name: "Deshnoke" },
      { name: "Devgarh" },
      { name: "Dhaulpur" },
      { name: "Didwana" },
      { name: "Dig" },
      { name: "Dungarpur" },
      { name: "Fatehpur" },
      { name: "Galiakot" },
      { name: "Ganganagar" },
      { name: "Gangapur" },
      { name: "Govindgarh" },
      { name: "Gulabpura" },
      { name: "Hanumangarh" },
      { name: "Hindaun" },
      { name: "Jahazpur" },
      { name: "Jaipur" },
      { name: "Jaisalmer" },
      { name: "Jaitaran" },
      { name: "Jalor" },
      { name: "Jalore" },
      { name: "Jhalawar" },
      { name: "Jhalrapatan" },
      { name: "Jhunjhunun" },
      { name: "Jobner" },
      { name: "Jodhpur" },
      { name: "Kaman" },
      { name: "Kanor" },
      { name: "Kapren" },
      { name: "Karanpur" },
      { name: "Karauli" },
      { name: "Kekri" },
      { name: "Keshorai Patan" },
      { name: "Khandela" },
      { name: "Khanpur" },
      { name: "Khetri" },
      { name: "Kishangarh" },
      { name: "Kota" },
      { name: "Kotputli" },
      { name: "Kuchaman" },
      { name: "Kuchera" },
      { name: "Kumher" },
      { name: "Kushalgarh" },
      { name: "Lachhmangarh Sikar" },
      { name: "Ladnun" },
      { name: "Lakheri" },
      { name: "Lalsot" },
      { name: "Losal" },
      { name: "Mahwah" },
      { name: "Makrana" },
      { name: "Malpura" },
      { name: "Mandal" },
      { name: "Mandalgarh" },
      { name: "Mandawar" },
      { name: "Mangrol" },
      { name: "Manohar Thana" },
      { name: "Manoharpur" },
      { name: "Meethari Marwar" },
      { name: "Merta" },
      { name: "Mundwa" },
      { name: "Nadbai" },
      { name: "Nagar" },
      { name: "Nagaur" },
      { name: "Nainwa" },
      { name: "Napasar" },
      { name: "Naraina" },
      { name: "Nasirabad" },
      { name: "Nathdwara" },
      { name: "Nawa" },
      { name: "Nawalgarh" },
      { name: "Neem ka Thana" },
      { name: "Nimaj" },
      { name: "Nimbahera" },
      { name: "Niwai" },
      { name: "Nohar" },
      { name: "Nokha" },
      { name: "Padampur" },
      { name: "Pali" },
      { name: "Partapur" },
      { name: "Parvatsar" },
      { name: "Phalodi" },
      { name: "Phulera" },
      { name: "Pilani" },
      { name: "Pilibangan" },
      { name: "Pindwara" },
      { name: "Pipar" },
      { name: "Pirawa" },
      { name: "Pokaran" },
      { name: "Pratapgarh" },
      { name: "Pushkar" },
      { name: "Raipur" },
      { name: "Raisinghnagar" },
      { name: "Rajakhera" },
      { name: "Rajaldesar" },
      { name: "Rajgarh" },
      { name: "Rajsamand" },
      { name: "Ramganj Mandi" },
      { name: "Ramgarh" },
      { name: "Rani" },
      { name: "Ratangarh" },
      { name: "Rawatbhata" },
      { name: "Rawatsar" },
      { name: "Ringas" },
      { name: "Sadri" },
      { name: "Salumbar" },
      { name: "Sambhar" },
      { name: "Samdari" },
      { name: "Sanchor" },
      { name: "Sangaria" },
      { name: "Sangod" },
      { name: "Sardarshahr" },
      { name: "Sarwar" },
      { name: "Sawai Madhopur" },
      { name: "Shahpura" },
      { name: "Sheoganj" },
      { name: "Sikar" },
      { name: "Sirohi" },
      { name: "Siwana" },
      { name: "Sojat" },
      { name: "Sri Dungargarh" },
      { name: "Sri Madhopur" },
      { name: "Sujangarh" },
      { name: "Suket" },
      { name: "Sunel" },
      { name: "Surajgarh" },
      { name: "Suratgarh" },
      { name: "Takhatgarh" },
      { name: "Taranagar" },
      { name: "Tijara" },
      { name: "Todabhim" },
      { name: "Todaraisingh" },
      { name: "Tonk" },
      { name: "Udaipur" },
      { name: "Udpura" },
      { name: "Uniara" },
      { name: "Wer" }
    ],
    "Sikkim": [
      { name: "East District" },
      { name: "Gangtok" },
      { name: "Gyalshing" },
      { name: "Jorethang" },
      { name: "Mangan" },
      { name: "Namchi" },
      { name: "Naya Bazar" },
      { name: "North District" },
      { name: "Rangpo" },
      { name: "Singtam" },
      { name: "South District" },
      { name: "West District" }
    ],
    "Tamil Nadu": [
      { name: "Abiramam" },
      { name: "Adirampattinam" },
      { name: "Aduthurai" },
      { name: "Alagapuram" },
      { name: "Alandur" },
      { name: "Alanganallur" },
      { name: "Alangayam" },
      { name: "Alangudi" },
      { name: "Alangulam" },
      { name: "Alappakkam" },
      { name: "Alwa Tirunagari" },
      { name: "Ambasamudram" },
      { name: "Ambattur" },
      { name: "Ambur" },
      { name: "Ammapettai" },
      { name: "Anamalais" },
      { name: "Andippatti" },
      { name: "Annamalainagar" },
      { name: "Annavasal" },
      { name: "Annur" },
      { name: "Anthiyur" },
      { name: "Arakkonam" },
      { name: "Arantangi" },
      { name: "Arcot" },
      { name: "Arimalam" },
      { name: "Ariyalur" },
      { name: "Arni" },
      { name: "Arumbavur" },
      { name: "Arumuganeri" },
      { name: "Aruppukkottai" },
      { name: "Aruvankad" },
      { name: "Attayyampatti" },
      { name: "Attur" },
      { name: "Auroville" },
      { name: "Avadi" },
      { name: "Avinashi" },
      { name: "Ayakudi" },
      { name: "Ayyampettai" },
      { name: "Belur" },
      { name: "Bhavani" },
      { name: "Bodinayakkanur" },
      { name: "Chengam" },
      { name: "Chennai" },
      { name: "Chennimalai" },
      { name: "Chetput" },
      { name: "Chettipalaiyam" },
      { name: "Cheyyar" },
      { name: "Cheyyur" },
      { name: "Chidambaram" },
      { name: "Chingleput" },
      { name: "Chinna Salem" },
      { name: "Chinnamanur" },
      { name: "Chinnasekkadu" },
      { name: "Cholapuram" },
      { name: "Coimbatore" },
      { name: "Colachel" },
      { name: "Cuddalore" },
      { name: "Cumbum" },
      { name: "Denkanikota" },
      { name: "Desur" },
      { name: "Devadanappatti" },
      { name: "Devakottai" },
      { name: "Dhali" },
      { name: "Dharapuram" },
      { name: "Dharmapuri" },
      { name: "Dindigul" },
      { name: "Dusi" },
      { name: "Elayirampannai" },
      { name: "Elumalai" },
      { name: "Eral" },
      { name: "Eraniel" },
      { name: "Erode" },
      { name: "Erumaippatti" },
      { name: "Ettaiyapuram" },
      { name: "Gandhi Nagar" },
      { name: "Gangaikondan" },
      { name: "Gangavalli" },
      { name: "Gingee" },
      { name: "Gobichettipalayam" },
      { name: "Gudalur" },
      { name: "Gudiyatham" },
      { name: "Guduvancheri" },
      { name: "Gummidipundi" },
      { name: "Harur" },
      { name: "Hosur" },
      { name: "Idappadi" },
      { name: "Ilampillai" },
      { name: "Iluppur" },
      { name: "Injambakkam" },
      { name: "Irugur" },
      { name: "Jalakandapuram" },
      { name: "Jalarpet" },
      { name: "Jayamkondacholapuram" },
      { name: "Kadambur" },
      { name: "Kadayanallur" },
      { name: "Kalakkadu" },
      { name: "Kalavai" },
      { name: "Kallakkurichchi" },
      { name: "Kallidaikurichi" },
      { name: "Kallupatti" },
      { name: "Kalugumalai" },
      { name: "Kamuthi" },
      { name: "Kanadukattan" },
      { name: "Kancheepuram" },
      { name: "Kanchipuram" },
      { name: "Kangayam" },
      { name: "Kanniyakumari" },
      { name: "Karaikkudi" },
      { name: "Karamadai" },
      { name: "Karambakkudi" },
      { name: "Kariapatti" },
      { name: "Karumbakkam" },
      { name: "Karur" },
      { name: "Katpadi" },
      { name: "Kattivakkam" },
      { name: "Kattupputtur" },
      { name: "Kaveripatnam" },
      { name: "Kayalpattinam" },
      { name: "Kayattar" },
      { name: "Keelakarai" },
      { name: "Kelamangalam" },
      { name: "Kil Bhuvanagiri" },
      { name: "Kilvelur" },
      { name: "Kiranur" },
      { name: "Kodaikanal" },
      { name: "Kodumudi" },
      { name: "Kombai" },
      { name: "Konganapuram" },
      { name: "Koothanallur" },
      { name: "Koradachcheri" },
      { name: "Korampallam" },
      { name: "Kotagiri" },
      { name: "Kottaiyur" },
      { name: "Kovilpatti" },
      { name: "Krishnagiri" },
      { name: "Kulattur" },
      { name: "Kulittalai" },
      { name: "Kumaralingam" },
      { name: "Kumbakonam" },
      { name: "Kunnattur" },
      { name: "Kurinjippadi" },
      { name: "Kuttalam" },
      { name: "Kuzhithurai" },
      { name: "Lalgudi" },
      { name: "Madambakkam" },
      { name: "Madipakkam" },
      { name: "Madukkarai" },
      { name: "Madukkur" },
      { name: "Madurai" },
      { name: "Madurantakam" },
      { name: "Mallapuram" },
      { name: "Mallasamudram" },
      { name: "Mallur" },
      { name: "Manali" },
      { name: "Manalurpettai" },
      { name: "Manamadurai" },
      { name: "Manappakkam" },
      { name: "Manapparai" },
      { name: "Manavalakurichi" },
      { name: "Mandapam" },
      { name: "Mangalam" },
      { name: "Mannargudi" },
      { name: "Marakkanam" },
      { name: "Marandahalli" },
      { name: "Masinigudi" },
      { name: "Mattur" },
      { name: "Mayiladuthurai" },
      { name: "Melur" },
      { name: "Mettuppalaiyam" },
      { name: "Mettur" },
      { name: "Minjur" },
      { name: "Mohanur" },
      { name: "Mudukulattur" },
      { name: "Mulanur" },
      { name: "Musiri" },
      { name: "Muttupet" },
      { name: "Naduvattam" },
      { name: "Nagapattinam" },
      { name: "Nagercoil" },
      { name: "Namagiripettai" },
      { name: "Namakkal" },
      { name: "Nambiyur" },
      { name: "Nambutalai" },
      { name: "Nandambakkam" },
      { name: "Nangavalli" },
      { name: "Nangilickondan" },
      { name: "Nanguneri" },
      { name: "Nannilam" },
      { name: "Naravarikuppam" },
      { name: "Nattam" },
      { name: "Nattarasankottai" },
      { name: "Needamangalam" },
      { name: "Neelankarai" },
      { name: "Negapatam" },
      { name: "Nellikkuppam" },
      { name: "Nilakottai" },
      { name: "Nilgiris" },
      { name: "Odugattur" },
      { name: "Omalur" },
      { name: "Ooty" },
      { name: "Padmanabhapuram" },
      { name: "Palakkodu" },
      { name: "Palamedu" },
      { name: "Palani" },
      { name: "Palavakkam" },
      { name: "Palladam" },
      { name: "Pallappatti" },
      { name: "Pallattur" },
      { name: "Pallavaram" },
      { name: "Pallikondai" },
      { name: "Pallipattu" },
      { name: "Pallippatti" },
      { name: "Panruti" },
      { name: "Papanasam" },
      { name: "Papireddippatti" },
      { name: "Papparappatti" },
      { name: "Paramagudi" },
      { name: "Pattukkottai" },
      { name: "Pennadam" },
      { name: "Pennagaram" },
      { name: "Pennathur" },
      { name: "Peraiyur" },
      { name: "Perambalur" },
      { name: "Peranamallur" },
      { name: "Peranampattu" },
      { name: "Peravurani" },
      { name: "Periyakulam" },
      { name: "Periyanayakkanpalaiyam" },
      { name: "Periyanegamam" },
      { name: "Periyapatti" },
      { name: "Periyapattinam" },
      { name: "Perundurai" },
      { name: "Perungudi" },
      { name: "Perur" },
      { name: "Pollachi" },
      { name: "Polur" },
      { name: "Ponnamaravati" },
      { name: "Ponneri" },
      { name: "Poonamalle" },
      { name: "Porur" },
      { name: "Pudukkottai" },
      { name: "Puduppatti" },
      { name: "Pudur" },
      { name: "Puduvayal" },
      { name: "Puliyangudi" },
      { name: "Puliyur" },
      { name: "Pullambadi" },
      { name: "Punjai Puliyampatti" },
      { name: "Rajapalaiyam" },
      { name: "Ramanathapuram" },
      { name: "Rameswaram" },
      { name: "Ranipet" },
      { name: "Rasipuram" },
      { name: "Saint Thomas Mount" },
      { name: "Salem" },
      { name: "Sathankulam" },
      { name: "Sathyamangalam" },
      { name: "Sattur" },
      { name: "Sayalkudi" },
      { name: "Seven Pagodas" },
      { name: "Sholinghur" },
      { name: "Singanallur" },
      { name: "Singapperumalkovil" },
      { name: "Sirkazhi" },
      { name: "Sirumugai" },
      { name: "Sivaganga" },
      { name: "Sivagiri" },
      { name: "Sivakasi" },
      { name: "Srimushnam" },
      { name: "Sriperumbudur" },
      { name: "Srivaikuntam" },
      { name: "Srivilliputhur" },
      { name: "Suchindram" },
      { name: "Sulur" },
      { name: "Surandai" },
      { name: "Swamimalai" },
      { name: "Tambaram" },
      { name: "Tanjore" },
      { name: "Taramangalam" },
      { name: "Tattayyangarpettai" },
      { name: "Thanjavur" },
      { name: "Tharangambadi" },
      { name: "Theni" },
      { name: "Thenkasi" },
      { name: "Thirukattupalli" },
      { name: "Thiruthani" },
      { name: "Thiruvaiyaru" },
      { name: "Thiruvallur" },
      { name: "Thiruvarur" },
      { name: "Thiruvidaimaruthur" },
      { name: "Thoothukudi" },
      { name: "Tindivanam" },
      { name: "Tinnanur" },
      { name: "Tiruchchendur" },
      { name: "Tiruchengode" },
      { name: "Tiruchirappalli" },
      { name: "Tirukkoyilur" },
      { name: "Tirumullaivasal" },
      { name: "Tirunelveli" },
      { name: "Tirunelveli Kattabo" },
      { name: "Tiruppalaikudi" },
      { name: "Tirupparangunram" },
      { name: "Tiruppur" },
      { name: "Tiruppuvanam" },
      { name: "Tiruttangal" },
      { name: "Tiruvannamalai" },
      { name: "Tiruvottiyur" },
      { name: "Tisaiyanvilai" },
      { name: "Tondi" },
      { name: "Turaiyur" },
      { name: "Udangudi" },
      { name: "Udumalaippettai" },
      { name: "Uppiliyapuram" },
      { name: "Usilampatti" },
      { name: "Uttamapalaiyam" },
      { name: "Uttiramerur" },
      { name: "Uttukkuli" },
      { name: "V.S.K.Valasai (Dindigul-Dist.)" },
      { name: "Vadakku Valliyur" },
      { name: "Vadakku Viravanallur" },
      { name: "Vadamadurai" },
      { name: "Vadippatti" },
      { name: "Valangaiman" },
      { name: "Valavanur" },
      { name: "Vallam" },
      { name: "Valparai" },
      { name: "Vandalur" },
      { name: "Vandavasi" },
      { name: "Vaniyambadi" },
      { name: "Vasudevanallur" },
      { name: "Vattalkundu" },
      { name: "Vedaraniyam" },
      { name: "Vedasandur" },
      { name: "Velankanni" },
      { name: "Vellanur" },
      { name: "Vellore" },
      { name: "Velur" },
      { name: "Vengavasal" },
      { name: "Vettaikkaranpudur" },
      { name: "Vettavalam" },
      { name: "Vijayapuri" },
      { name: "Vikravandi" },
      { name: "Vilattikulam" },
      { name: "Villupuram" },
      { name: "Viraganur" },
      { name: "Virudhunagar" },
      { name: "Vriddhachalam" },
      { name: "Walajapet" },
      { name: "Wallajahbad" },
      { name: "Wellington" }
    ],
    "Telangana": [
      { name: "Adilabad" },
      { name: "Alampur" },
      { name: "Andol" },
      { name: "Asifabad" },
      { name: "Balapur" },
      { name: "Banswada" },
      { name: "Bellampalli" },
      { name: "Bhadrachalam" },
      { name: "Bhadradri Kothagudem" },
      { name: "Bhaisa" },
      { name: "Bhongir" },
      { name: "Bodhan" },
      { name: "Chandur" },
      { name: "Chatakonda" },
      { name: "Dasnapur" },
      { name: "Devarkonda" },
      { name: "Dornakal" },
      { name: "Farrukhnagar" },
      { name: "Gaddi Annaram" },
      { name: "Gadwal" },
      { name: "Ghatkesar" },
      { name: "Gopalur" },
      { name: "Gudur" },
      { name: "Hyderabad" },
      { name: "Jagtial" },
      { name: "Jangaon" },
      { name: "Jangoan" },
      { name: "Jayashankar Bhupalapally" },
      { name: "Jogulamba Gadwal" },
      { name: "Kagaznagar" },
      { name: "Kamareddi" },
      { name: "Kamareddy" },
      { name: "Karimnagar" },
      { name: "Khammam" },
      { name: "Kodar" },
      { name: "Koratla" },
      { name: "Kothapet" },
      { name: "Kottagudem" },
      { name: "Kottapalli" },
      { name: "Kukatpalli" },
      { name: "Kyathampalle" },
      { name: "Lakshettipet" },
      { name: "Lal Bahadur Nagar" },
      { name: "Mahabubabad" },
      { name: "Mahbubnagar" },
      { name: "Malkajgiri" },
      { name: "Mancheral" },
      { name: "Mandamarri" },
      { name: "Manthani" },
      { name: "Manuguru" },
      { name: "Medak" },
      { name: "Medchal" },
      { name: "Medchal Malkajgiri" },
      { name: "Mirialguda" },
      { name: "Nagar Karnul" },
      { name: "Nalgonda" },
      { name: "Narayanpet" },
      { name: "Narsingi" },
      { name: "Naspur" },
      { name: "Nirmal" },
      { name: "Nizamabad" },
      { name: "Paloncha" },
      { name: "Palwancha" },
      { name: "Patancheru" },
      { name: "Peddapalli" },
      { name: "Quthbullapur" },
      { name: "Rajanna Sircilla" },
      { name: "Ramagundam" },
      { name: "Ramgundam" },
      { name: "Rangareddi" },
      { name: "Sadaseopet" },
      { name: "Sangareddi" },
      { name: "Sathupalli" },
      { name: "Secunderabad" },
      { name: "Serilingampalle" },
      { name: "Siddipet" },
      { name: "Singapur" },
      { name: "Sirpur" },
      { name: "Sirsilla" },
      { name: "Sriramnagar" },
      { name: "Suriapet" },
      { name: "Tandur" },
      { name: "Uppal Kalan" },
      { name: "Vemalwada" },
      { name: "Vikarabad" },
      { name: "Wanparti" },
      { name: "Warangal" },
      { name: "Yellandu" },
      { name: "Zahirabad" }
    ],
    "Tripura": [
      { name: "Agartala" },
      { name: "Amarpur" },
      { name: "Ambasa" },
      { name: "Barjala" },
      { name: "Belonia" },
      { name: "Dhalai" },
      { name: "Dharmanagar" },
      { name: "Gomati" },
      { name: "Kailashahar" },
      { name: "Kamalpur" },
      { name: "Khowai" },
      { name: "North Tripura" },
      { name: "Ranir Bazar" },
      { name: "Sabrum" },
      { name: "Sonamura" },
      { name: "South Tripura" },
      { name: "Udaipur" },
      { name: "Unakoti" },
      { name: "West Tripura" }
    ],
    "Uttar Pradesh": [
      { name: "Achhnera" },
      { name: "Afzalgarh" },
      { name: "Agra" },
      { name: "Ahraura" },
      { name: "Aidalpur" },
      { name: "Airwa" },
      { name: "Akbarpur" },
      { name: "Akola" },
      { name: "Aliganj" },
      { name: "Aligarh" },
      { name: "Allahabad" },
      { name: "Allahganj" },
      { name: "Amanpur" },
      { name: "Amauli" },
      { name: "Ambahta" },
      { name: "Ambedkar Nagar" },
      { name: "Amethi" },
      { name: "Amroha" },
      { name: "Anandnagar" },
      { name: "Antu" },
      { name: "Anupshahr" },
      { name: "Aonla" },
      { name: "Araul" },
      { name: "Asalatganj" },
      { name: "Atarra" },
      { name: "Atrauli" },
      { name: "Atraulia" },
      { name: "Auraiya" },
      { name: "Auras" },
      { name: "Ayodhya" },
      { name: "Azamgarh" },
      { name: "Azizpur" },
      { name: "Baberu" },
      { name: "Babina" },
      { name: "Babrala" },
      { name: "Babugarh" },
      { name: "Bachhraon" },
      { name: "Bachhrawan" },
      { name: "Baghpat" },
      { name: "Baghra" },
      { name: "Bah" },
      { name: "Baheri" },
      { name: "Bahjoi" },
      { name: "Bahraich" },
      { name: "Bahraigh" },
      { name: "Bahsuma" },
      { name: "Bahua" },
      { name: "Bajna" },
      { name: "Bakewar" },
      { name: "Baksar" },
      { name: "Balamau" },
      { name: "Baldeo" },
      { name: "Baldev" },
      { name: "Ballia" },
      { name: "Balrampur" },
      { name: "Banat" },
      { name: "Banbasa" },
      { name: "Banda" },
      { name: "Bangarmau" },
      { name: "Bansdih" },
      { name: "Bansgaon" },
      { name: "Bansi" },
      { name: "Banthra" },
      { name: "Bara Banki" },
      { name: "Baragaon" },
      { name: "Baraut" },
      { name: "Bareilly" },
      { name: "Barhalganj" },
      { name: "Barkhera" },
      { name: "Barkhera Kalan" },
      { name: "Barokhar" },
      { name: "Barsana" },
      { name: "Barwar (Lakhimpur Kheri)" },
      { name: "Basti" },
      { name: "Behat" },
      { name: "Bela" },
      { name: "Belthara" },
      { name: "Beniganj" },
      { name: "Beswan" },
      { name: "Bewar" },
      { name: "Bhadarsa" },
      { name: "Bhadohi" },
      { name: "Bhagwantnagar" },
      { name: "Bharatpura" },
      { name: "Bhargain" },
      { name: "Bharthana" },
      { name: "Bharwari" },
      { name: "Bhaupur" },
      { name: "Bhimtal" },
      { name: "Bhinga" },
      { name: "Bhognipur" },
      { name: "Bhongaon" },
      { name: "Bidhnu" },
      { name: "Bidhuna" },
      { name: "Bighapur" },
      { name: "Bighapur Khurd" },
      { name: "Bijnor" },
      { name: "Bikapur" },
      { name: "Bilari" },
      { name: "Bilariaganj" },
      { name: "Bilaspur" },
      { name: "Bilgram" },
      { name: "Bilhaur" },
      { name: "Bilsanda" },
      { name: "Bilsi" },
      { name: "Bilthra" },
      { name: "Binauli" },
      { name: "Binaur" },
      { name: "Bindki" },
      { name: "Birdpur" },
      { name: "Birpur" },
      { name: "Bisalpur" },
      { name: "Bisanda Buzurg" },
      { name: "Bisauli" },
      { name: "Bisenda Buzurg" },
      { name: "Bishunpur Urf Maharajganj" },
      { name: "Biswan" },
      { name: "Bithur" },
      { name: "Budaun" },
      { name: "Budhana" },
      { name: "Bulandshahr" },
      { name: "Captainganj" },
      { name: "Chail" },
      { name: "Chakia" },
      { name: "Chandauli" },
      { name: "Chandauli District" },
      { name: "Chandausi" },
      { name: "Chandpur" },
      { name: "Chanduasi" },
      { name: "Charkhari" },
      { name: "Charthawal" },
      { name: "Chhaprauli" },
      { name: "Chharra" },
      { name: "Chhata" },
      { name: "Chhibramau" },
      { name: "Chhitauni" },
      { name: "Chhutmalpur" },
      { name: "Chillupar" },
      { name: "Chirgaon" },
      { name: "Chitrakoot" },
      { name: "Chitrakoot Dham" },
      { name: "Chopan" },
      { name: "Chunar" },
      { name: "Churk" },
      { name: "Colonelganj" },
      { name: "Dadri" },
      { name: "Dalmau" },
      { name: "Dankaur" },
      { name: "Daraganj" },
      { name: "Daranagar" },
      { name: "Dasna" },
      { name: "Dataganj" },
      { name: "Daurala" },
      { name: "Dayal Bagh" },
      { name: "Deoband" },
      { name: "Deogarh" },
      { name: "Deoranian" },
      { name: "Deoria" },
      { name: "Derapur" },
      { name: "Dewa" },
      { name: "Dhampur" },
      { name: "Dhanaura" },
      { name: "Dhanghata" },
      { name: "Dharau" },
      { name: "Dhaurahra" },
      { name: "Dibai" },
      { name: "Divrasai" },
      { name: "Dohrighat" },
      { name: "Domariaganj" },
      { name: "Dostpur" },
      { name: "Dudhi" },
      { name: "Etah" },
      { name: "Etawah" },
      { name: "Etmadpur" },
      { name: "Faizabad" },
      { name: "Farah" },
      { name: "Faridnagar" },
      { name: "Faridpur" },
      { name: "Farrukhabad" },
      { name: "Fatehabad" },
      { name: "Fatehganj West" },
      { name: "Fatehgarh" },
      { name: "Fatehpur" },
      { name: "Fatehpur (Barabanki)" },
      { name: "Fatehpur Chaurasi" },
      { name: "Fatehpur Sikri" },
      { name: "Firozabad" },
      { name: "Fyzabad" },
      { name: "Gahlon" },
      { name: "Gahmar" },
      { name: "Gaini" },
      { name: "Gajraula" },
      { name: "Gangoh" },
      { name: "Ganj Dundawara" },
      { name: "Ganj Dundwara" },
      { name: "Ganj Muradabad" },
      { name: "Garautha" },
      { name: "Garhi Pukhta" },
      { name: "Garhmuktesar" },
      { name: "Garhwa" },
      { name: "Gauriganj" },
      { name: "Gautam Buddha Nagar" },
      { name: "Gawan" },
      { name: "Ghatampur" },
      { name: "Ghaziabad" },
      { name: "Ghazipur" },
      { name: "Ghiror" },
      { name: "Ghorawal" },
      { name: "Ghosi" },
      { name: "Gohand" },
      { name: "Gokul" },
      { name: "Gola Bazar" },
      { name: "Gola Gokarannath" },
      { name: "Gonda" },
      { name: "Gonda (Aligarh)" },
      { name: "Gonda City" },
      { name: "Gopamau" },
      { name: "Gorakhpur" },
      { name: "Gosainganj" },
      { name: "Goshainganj" },
      { name: "Govardhan" },
      { name: "Greater Noida" },
      { name: "Gulaothi" },
      { name: "Gunnaur" },
      { name: "Gursahaiganj" },
      { name: "Gursarai" },
      { name: "Gyanpur" },
      { name: "Haldaur" },
      { name: "Hamirpur" },
      { name: "Handia" },
      { name: "Hapur" },
      { name: "Haraipur" },
      { name: "Haraiya" },
      { name: "Harchandpur" },
      { name: "Hardoi" },
      { name: "Harduaganj" },
      { name: "Hasanpur" },
      { name: "Hastinapur" },
      { name: "Hata" },
      { name: "Hata (India)" },
      { name: "Hathras" },
      { name: "Hulas" },
      { name: "Ibrahimpur" },
      { name: "Iglas" },
      { name: "Ikauna" },
      { name: "Indergarh" },
      { name: "Indragarh" },
      { name: "Islamnagar" },
      { name: "Islamnagar (Badaun)" },
      { name: "Itaunja" },
      { name: "Itimadpur" },
      { name: "Jagdishpur" },
      { name: "Jagnair" },
      { name: "Jahanabad" },
      { name: "Jahanabad (Pilibhit)" },
      { name: "Jahangirabad" },
      { name: "Jahangirpur" },
      { name: "Jainpur" },
      { name: "Jais" },
      { name: "Jalalabad" },
      { name: "Jalali" },
      { name: "Jalalpur" },
      { name: "Jalaun" },
      { name: "Jalesar" },
      { name: "Janghai" },
      { name: "Jansath" },
      { name: "Jarwa" },
      { name: "Jarwal" },
      { name: "Jasrana" },
      { name: "Jaswantnagar" },
      { name: "Jaunpur" },
      { name: "Jewar" },
      { name: "Jhajhar" },
      { name: "Jhalu" },
      { name: "Jhansi" },
      { name: "Jhinjhak" },
      { name: "Jhinjhana" },
      { name: "Jhusi" },
      { name: "Jiyanpur" },
      { name: "Jyotiba Phule Nagar" },
      { name: "Kabrai" },
      { name: "Kachhwa" },
      { name: "Kadaura" },
      { name: "Kadipur" },
      { name: "Kagarol" },
      { name: "Kaimganj" },
      { name: "Kairana" },
      { name: "Kakori" },
      { name: "Kakrala" },
      { name: "Kalinagar" },
      { name: "Kalpi" },
      { name: "Kalyanpur" },
      { name: "Kamalganj" },
      { name: "Kampil" },
      { name: "Kandhla" },
      { name: "Kannauj" },
      { name: "Kanpur" },
      { name: "Kanpur Dehat" },
      { name: "Kant" },
      { name: "Kanth" },
      { name: "Kaptanganj" },
      { name: "Kara" },
      { name: "Karari" },
      { name: "Karbigwan" },
      { name: "Karchana" },
      { name: "Karhal" },
      { name: "Kasganj" },
      { name: "Katra" },
      { name: "Kausani" },
      { name: "Kaushambi District" },
      { name: "Kemri" },
      { name: "Khada" },
      { name: "Khaga" },
      { name: "Khailar" },
      { name: "Khair" },
      { name: "Khairabad" },
      { name: "Khalilabad" },
      { name: "Khanpur" },
      { name: "Kharela" },
      { name: "Khargupur" },
      { name: "Kharkhauda" },
      { name: "Khatauli" },
      { name: "Khekra" },
      { name: "Kheri" },
      { name: "Khudaganj" },
      { name: "Khurja" },
      { name: "Khutar" },
      { name: "Kirakat" },
      { name: "Kiraoli" },
      { name: "Kiratpur" },
      { name: "Kishanpur" },
      { name: "Kishanpur baral" },
      { name: "Kishni" },
      { name: "Kithor" },
      { name: "Konch" },
      { name: "Kopaganj" },
      { name: "Kosi" },
      { name: "Kota" },
      { name: "Kotra" },
      { name: "Kuchesar" },
      { name: "Kudarkot" },
      { name: "Kulpahar" },
      { name: "Kunda" },
      { name: "Kundarkhi" },
      { name: "Kundarki" },
      { name: "Kurara" },
      { name: "Kurebharsaidkhanpur" },
      { name: "Kushinagar" },
      { name: "Kusmara" },
      { name: "Kuthaund" },
      { name: "Laharpur" },
      { name: "Lakhimpur" },
      { name: "Lakhna" },
      { name: "Lalganj" },
      { name: "Lalitpur" },
      { name: "Lambhua" },
      { name: "Lar" },
      { name: "Lawar" },
      { name: "Lawar Khas" },
      { name: "Loni" },
      { name: "Lucknow" },
      { name: "Lucknow District" },
      { name: "Machhali Shahar" },
      { name: "Machhlishahr" },
      { name: "Madhoganj" },
      { name: "Madhogarh" },
      { name: "Maghar" },
      { name: "Mahaban" },
      { name: "Maharajganj" },
      { name: "Mahmudabad" },
      { name: "Mahoba" },
      { name: "Maholi" },
      { name: "Mahrajganj" },
      { name: "Mahrajganj (Raebareli)" },
      { name: "Mahroni" },
      { name: "Mahul" },
      { name: "Mailani" },
      { name: "Mainpuri" },
      { name: "Majhupur" },
      { name: "Makanpur" },
      { name: "Malasa" },
      { name: "Malihabad" },
      { name: "Mandawar" },
      { name: "Maniar" },
      { name: "Manikpur" },
      { name: "Manjhanpur" },
      { name: "Mankapur" },
      { name: "Marahra" },
      { name: "Mariahu" },
      { name: "Mataundh" },
      { name: "Mathura" },
      { name: "Mau" },
      { name: "Mau Aima" },
      { name: "Mau Aimma" },
      { name: "Maudaha" },
      { name: "Mauranwan" },
      { name: "Maurawan" },
      { name: "Mawana" },
      { name: "Mawar" },
      { name: "Meerut" },
      { name: "Mehdawal" },
      { name: "Mehnagar" },
      { name: "Mehndawal" },
      { name: "Milak" },
      { name: "Milkipur" },
      { name: "Miranpur" },
      { name: "Miranpur Katra" },
      { name: "Mirganj" },
      { name: "Mirzapur" },
      { name: "Misrikh" },
      { name: "Mohan" },
      { name: "Mohanpur" },
      { name: "Moradabad" },
      { name: "Moth" },
      { name: "Mubarakpur" },
      { name: "Mughal Sarai" },
      { name: "Muhammadabad" },
      { name: "Mukteshwar" },
      { name: "Mungra Badshahpur" },
      { name: "Munsyari" },
      { name: "Muradabad" },
      { name: "Muradnagar" },
      { name: "Mursan" },
      { name: "Musafir-Khana" },
      { name: "Musafirkhana" },
      { name: "Muzaffarnagar" },
      { name: "Nadigaon" },
      { name: "Nagina" },
      { name: "Nagla" },
      { name: "Nagram" },
      { name: "Najibabad" },
      { name: "Nakur" },
      { name: "Nanauta" },
      { name: "Nandgaon" },
      { name: "Nanpara" },
      { name: "Narauli" },
      { name: "Naraura" },
      { name: "Narora" },
      { name: "Naugama" },
      { name: "Naurangpur" },
      { name: "Nautanwa" },
      { name: "Nawabganj" },
      { name: "Nawabganj (Barabanki)" },
      { name: "Nawabganj (Bareilly)" },
      { name: "Newara" },
      { name: "Nichlaul" },
      { name: "Nigoh" },
      { name: "Nihtaur" },
      { name: "Niwari" },
      { name: "Nizamabad" },
      { name: "Noida" },
      { name: "Nurpur" },
      { name: "Obra" },
      { name: "Orai" },
      { name: "Oran" },
      { name: "Pachperwa" },
      { name: "Padrauna" },
      { name: "Pahasu" },
      { name: "Paigaon" },
      { name: "Pali" },
      { name: "Palia Kalan" },
      { name: "Paras Rampur" },
      { name: "Parichha" },
      { name: "Parichhatgarh" },
      { name: "Parshadepur" },
      { name: "Pathakpura" },
      { name: "Patiali" },
      { name: "Patti" },
      { name: "Pawayan" },
      { name: "Payagpur" },
      { name: "Phalauda" },
      { name: "Phaphamau" },
      { name: "Phaphund" },
      { name: "Phariha" },
      { name: "Pheona" },
      { name: "Phulpur" },
      { name: "Pichhaura" },
      { name: "Pihani" },
      { name: "Pilibhit" },
      { name: "Pilkhua" },
      { name: "Pilkhuwa" },
      { name: "Pinahat" },
      { name: "Pipraich" },
      { name: "Pipri" },
      { name: "Pratapgarh" },
      { name: "Prayagraj (Allahabad)" },
      { name: "Pukhrayan" },
      { name: "Puranpur" },
      { name: "Purmafi" },
      { name: "Purwa" },
      { name: "Qadirganj" },
      { name: "Rabupura" },
      { name: "Radha Kund" },
      { name: "Radhakund" },
      { name: "Raebareli" },
      { name: "Rajapur" },
      { name: "Ramkola" },
      { name: "Ramnagar" },
      { name: "Rampur" },
      { name: "Rampura" },
      { name: "Ranipur" },
      { name: "Ranipur Barsi" },
      { name: "Rasra" },
      { name: "Rasulabad" },
      { name: "Rath" },
      { name: "Raya" },
      { name: "Rehar" },
      { name: "Renukoot" },
      { name: "Renukut" },
      { name: "Reoti" },
      { name: "Reotipur" },
      { name: "Richha" },
      { name: "Robertsganj" },
      { name: "Rudarpur" },
      { name: "Rudauli" },
      { name: "Rura" },
      { name: "Sabalpur" },
      { name: "Sachendi" },
      { name: "Sadabad" },
      { name: "Sadat" },
      { name: "Safipur" },
      { name: "Saharanpur" },
      { name: "Sahaspur" },
      { name: "Sahaswan" },
      { name: "Sahawar" },
      { name: "Sahibabad" },
      { name: "Sahpau" },
      { name: "Saidpur" },
      { name: "Sakhanu" },
      { name: "Sakit" },
      { name: "Salempur" },
      { name: "Salon" },
      { name: "Sambhal" },
      { name: "Samthar" },
      { name: "Sandi" },
      { name: "Sandila" },
      { name: "Sant Kabir Nagar" },
      { name: "Sant Ravi Das Nagar" },
      { name: "Sarai Akil" },
      { name: "Sarai Ekdil" },
      { name: "Sarai Mir" },
      { name: "Sarauli" },
      { name: "Sardhana" },
      { name: "Sarila" },
      { name: "Sarurpur" },
      { name: "Sasni" },
      { name: "Satrikh" },
      { name: "Saurikh" },
      { name: "Sector" },
      { name: "Seohara" },
      { name: "Shahabad" },
      { name: "Shahganj" },
      { name: "Shahi" },
      { name: "Shahjahanpur" },
      { name: "Shahpur" },
      { name: "Shamli" },
      { name: "Shamsabad" },
      { name: "Shankargarh" },
      { name: "Shergarh" },
      { name: "Sherkot" },
      { name: "Shibnagar" },
      { name: "Shikarpur" },
      { name: "Shikarpur (Bulandshahr)" },
      { name: "Shikohabad" },
      { name: "Shishgarh" },
      { name: "Shivrajpur" },
      { name: "Shrawasti" },
      { name: "Siddharthnagar" },
      { name: "Siddhaur" },
      { name: "Sidhauli" },
      { name: "Sidhpura" },
      { name: "Sikandarabad" },
      { name: "Sikandarpur" },
      { name: "Sikandra" },
      { name: "Sikandra Rao" },
      { name: "Sikandrabad" },
      { name: "Sirathu" },
      { name: "Sirsa" },
      { name: "Sirsaganj" },
      { name: "Sirsi" },
      { name: "Sisauli" },
      { name: "Siswa Bazar" },
      { name: "Sitapur" },
      { name: "Sonbhadra" },
      { name: "Soron" },
      { name: "Suar" },
      { name: "Sultanpur" },
      { name: "Surianwan" },
      { name: "Tajpur" },
      { name: "Talbahat" },
      { name: "Talgram" },
      { name: "Tanda" },
      { name: "Terha" },
      { name: "Thakurdwara" },
      { name: "Thana Bhawan" },
      { name: "Tigri" },
      { name: "Tikaitnagar" },
      { name: "Tikri" },
      { name: "Tilhar" },
      { name: "Tilsahri" },
      { name: "Tindwari" },
      { name: "Titron" },
      { name: "Tori Fatehpur" },
      { name: "Tori-Fatehpur" },
      { name: "Tulsipur" },
      { name: "Tundla" },
      { name: "Ugu" },
      { name: "Ujhani" },
      { name: "Umri" },
      { name: "Un" },
      { name: "Unnao" },
      { name: "Usawan" },
      { name: "Usehat" },
      { name: "Uska" },
      { name: "Utraula" },
      { name: "Varanasi" },
      { name: "Vindhyachal" },
      { name: "Vrindavan" },
      { name: "Walterganj" },
      { name: "Wazirganj" },
      { name: "Yusufpur" },
      { name: "Zafarabad" },
      { name: "Zaidpur" },
      { name: "Zamania" }
    ],
    "Uttarakhand": [
      { name: "Almora" },
      { name: "Bageshwar" },
      { name: "Barkot" },
      { name: "Bazpur" },
      { name: "Bhim Tal" },
      { name: "Bhowali" },
      { name: "Birbhaddar" },
      { name: "Chakrata" },
      { name: "Chamoli" },
      { name: "Champawat" },
      { name: "Clement Town" },
      { name: "Dehradun" },
      { name: "Devaprayag" },
      { name: "Dharchula" },
      { name: "Doiwala" },
      { name: "Dugadda" },
      { name: "Dwarahat" },
      { name: "Garhwal" },
      { name: "Haldwani" },
      { name: "Harbatpur" },
      { name: "Haridwar" },
      { name: "Jaspur" },
      { name: "Joshimath" },
      { name: "Kaladhungi" },
      { name: "Kalagarh Project Colony" },
      { name: "Kashipur" },
      { name: "Khatima" },
      { name: "Kichha" },
      { name: "Kotdwara" },
      { name: "Laksar" },
      { name: "Lansdowne" },
      { name: "Lohaghat" },
      { name: "Manglaur" },
      { name: "Mussoorie" },
      { name: "Naini Tal" },
      { name: "Narendranagar" },
      { name: "Pauri" },
      { name: "Pipalkoti" },
      { name: "Pithoragarh" },
      { name: "Raipur" },
      { name: "Raiwala Bara" },
      { name: "Ramnagar" },
      { name: "Ranikhet" },
      { name: "Rishikesh" },
      { name: "Roorkee" },
      { name: "Rudraprayag" },
      { name: "Sitarganj" },
      { name: "Srinagar" },
      { name: "Sultanpur" },
      { name: "Tanakpur" },
      { name: "Tehri" },
      { name: "Tehri-Garhwal" },
      { name: "Udham Singh Nagar" },
      { name: "Uttarkashi" },
      { name: "Vikasnagar" }
    ],
    "West Bengal": [
      { name: "Adra" },
      { name: "Ahmedpur" },
      { name: "Aistala" },
      { name: "Aknapur" },
      { name: "Alipurduar" },
      { name: "Amlagora" },
      { name: "Amta" },
      { name: "Amtala" },
      { name: "Andal" },
      { name: "Arambagh community development block" },
      { name: "Asansol" },
      { name: "Ashoknagar Kalyangarh" },
      { name: "Badkulla" },
      { name: "Baduria" },
      { name: "Bagdogra" },
      { name: "Bagnan" },
      { name: "Bagula" },
      { name: "Bahula" },
      { name: "Baidyabati" },
      { name: "Bakreswar" },
      { name: "Balarampur" },
      { name: "Bali Chak" },
      { name: "Bally" },
      { name: "Balurghat" },
      { name: "Bamangola community development block" },
      { name: "Baneswar" },
      { name: "Bangaon" },
      { name: "Bankra" },
      { name: "Bankura" },
      { name: "Bansberia" },
      { name: "Bansihari community development block" },
      { name: "Barabazar" },
      { name: "Baranagar" },
      { name: "Barasat" },
      { name: "Bardhaman" },
      { name: "Barjora" },
      { name: "Barrackpore" },
      { name: "Baruipur" },
      { name: "Basanti" },
      { name: "Basirhat" },
      { name: "Bawali" },
      { name: "Begampur" },
      { name: "Belda" },
      { name: "Beldanga" },
      { name: "Beliatore" },
      { name: "Berhampore" },
      { name: "Bhadreswar" },
      { name: "Bhandardaha" },
      { name: "Bhatpara" },
      { name: "Birbhum district" },
      { name: "Birpara" },
      { name: "Bishnupur" },
      { name: "Bolpur" },
      { name: "Budge Budge" },
      { name: "Canning" },
      { name: "Chakapara" },
      { name: "Chakdaha" },
      { name: "Champadanga" },
      { name: "Champahati" },
      { name: "Champdani" },
      { name: "Chandannagar" },
      { name: "Chandrakona" },
      { name: "Chittaranjan" },
      { name: "Churulia" },
      { name: "Contai" },
      { name: "Cooch Behar" },
      { name: "Cossimbazar" },
      { name: "Dakshin Dinajpur district" },
      { name: "Dalkola" },
      { name: "Dam Dam" },
      { name: "Darjeeling" },
      { name: "Daulatpur" },
      { name: "Debagram" },
      { name: "Debipur" },
      { name: "Dhaniakhali community development block" },
      { name: "Dhulagari" },
      { name: "Dhulian" },
      { name: "Dhupguri" },
      { name: "Diamond Harbour" },
      { name: "Digha" },
      { name: "Dinhata" },
      { name: "Domjur" },
      { name: "Dubrajpur" },
      { name: "Durgapur" },
      { name: "Egra" },
      { name: "Falakata" },
      { name: "Farakka" },
      { name: "Fort Gloster" },
      { name: "Gaighata community development block" },
      { name: "Gairkata" },
      { name: "Gangadharpur" },
      { name: "Gangarampur" },
      { name: "Garui" },
      { name: "Garulia" },
      { name: "Ghatal" },
      { name: "Giria" },
      { name: "Gobardanga" },
      { name: "Gobindapur" },
      { name: "Gopalpur" },
      { name: "Gopinathpur" },
      { name: "Gorubathan" },
      { name: "Gosaba" },
      { name: "Gosanimari" },
      { name: "Gurdaha" },
      { name: "Guskhara" },
      { name: "Habra" },
      { name: "Haldia" },
      { name: "Haldibari" },
      { name: "Halisahar" },
      { name: "Harindanga" },
      { name: "Haringhata" },
      { name: "Haripur" },
      { name: "Hasimara" },
      { name: "Hindusthan Cables Town" },
      { name: "Hooghly district" },
      { name: "Howrah" },
      { name: "Ichapur" },
      { name: "Indpur community development block" },
      { name: "Ingraj Bazar" },
      { name: "Islampur" },
      { name: "Jafarpur" },
      { name: "Jaigaon" },
      { name: "Jalpaiguri" },
      { name: "Jamuria" },
      { name: "Jangipur" },
      { name: "Jaynagar Majilpur" },
      { name: "Jejur" },
      { name: "Jhalida" },
      { name: "Jhargram" },
      { name: "Jhilimili" },
      { name: "Kakdwip" },
      { name: "Kalaikunda" },
      { name: "Kaliaganj" },
      { name: "Kalimpong" },
      { name: "Kalna" },
      { name: "Kalyani" },
      { name: "Kamarhati" },
      { name: "Kamarpukur" },
      { name: "Kanchrapara" },
      { name: "Kandi" },
      { name: "Karimpur" },
      { name: "Katwa" },
      { name: "Kenda" },
      { name: "Keshabpur" },
      { name: "Kharagpur" },
      { name: "Kharar" },
      { name: "Kharba" },
      { name: "Khardaha" },
      { name: "Khatra" },
      { name: "Kirnahar" },
      { name: "Kolkata" },
      { name: "Konnagar" },
      { name: "Krishnanagar" },
      { name: "Krishnapur" },
      { name: "Kshirpai" },
      { name: "Kulpi" },
      { name: "Kultali" },
      { name: "Kulti" },
      { name: "Kurseong" },
      { name: "Lalgarh" },
      { name: "Lalgola" },
      { name: "Loyabad" },
      { name: "Madanpur" },
      { name: "Madhyamgram" },
      { name: "Mahiari" },
      { name: "Mahishadal community development block" },
      { name: "Mainaguri" },
      { name: "Manikpara" },
      { name: "Masila" },
      { name: "Mathabhanga" },
      { name: "Matiali community development block" },
      { name: "Matigara community development block" },
      { name: "Medinipur" },
      { name: "Mejia community development block" },
      { name: "Memari" },
      { name: "Mirik" },
      { name: "Mohanpur community development block" },
      { name: "Monoharpur" },
      { name: "Muragacha" },
      { name: "Muri" },
      { name: "Murshidabad" },
      { name: "Nabadwip" },
      { name: "Nabagram" },
      { name: "Nadia district" },
      { name: "Nagarukhra" },
      { name: "Nagrakata" },
      { name: "Naihati" },
      { name: "Naksalbari" },
      { name: "Nalhati" },
      { name: "Nalpur" },
      { name: "Namkhana community development block" },
      { name: "Nandigram" },
      { name: "Nangi" },
      { name: "Nayagram community development block" },
      { name: "North 24 Parganas district" },
      { name: "Odlabari" },
      { name: "Paikpara" },
      { name: "Panagarh" },
      { name: "Panchla" },
      { name: "Panchmura" },
      { name: "Pandua" },
      { name: "Panihati" },
      { name: "Panskura" },
      { name: "Parbatipur" },
      { name: "Paschim Medinipur district" },
      { name: "Patiram" },
      { name: "Patrasaer" },
      { name: "Patuli" },
      { name: "Pujali" },
      { name: "Puncha community development block" },
      { name: "Purba Medinipur district" },
      { name: "Purulia" },
      { name: "Raghudebbati" },
      { name: "Raghunathpur" },
      { name: "Raiganj" },
      { name: "Rajmahal" },
      { name: "Rajnagar community development block" },
      { name: "Ramchandrapur" },
      { name: "Ramjibanpur" },
      { name: "Ramnagar" },
      { name: "Rampur Hat" },
      { name: "Ranaghat" },
      { name: "Raniganj" },
      { name: "Raypur" },
      { name: "Rishra" },
      { name: "Sahapur" },
      { name: "Sainthia" },
      { name: "Salanpur community development block" },
      { name: "Sankarpur" },
      { name: "Sankrail" },
      { name: "Santipur" },
      { name: "Santoshpur" },
      { name: "Santuri community development block" },
      { name: "Sarenga" },
      { name: "Serampore" },
      { name: "Serpur" },
      { name: "Shyamnagar West Bengal" },
      { name: "Siliguri" },
      { name: "Singur" },
      { name: "Sodpur" },
      { name: "Solap" },
      { name: "Sonada" },
      { name: "Sonamukhi" },
      { name: "Sonarpur community development block" },
      { name: "South 24 Parganas district" },
      { name: "Srikhanda" },
      { name: "Srirampur" },
      { name: "Suri" },
      { name: "Swarupnagar community development block" },
      { name: "Takdah" },
      { name: "Taki" },
      { name: "Tamluk" },
      { name: "Tarakeswar" },
      { name: "Titagarh" },
      { name: "Tufanganj" },
      { name: "Tulin" },
      { name: "Uchalan" },
      { name: "Ula" },
      { name: "Uluberia" },
      { name: "Uttar Dinajpur district" },
      { name: "Uttarpara Kotrung" }
    ]
  }
];
